(function () {
// packages/alpinejs/src/scheduler.js
var $84556724c483b9e3$var$flushPending = false;
var $84556724c483b9e3$var$flushing = false;
var $84556724c483b9e3$var$queue = [];
var $84556724c483b9e3$var$lastFlushedIndex = -1;
function $84556724c483b9e3$var$scheduler(callback) {
    $84556724c483b9e3$var$queueJob(callback);
}
function $84556724c483b9e3$var$queueJob(job) {
    if (!$84556724c483b9e3$var$queue.includes(job)) $84556724c483b9e3$var$queue.push(job);
    $84556724c483b9e3$var$queueFlush();
}
function $84556724c483b9e3$var$dequeueJob(job) {
    let index = $84556724c483b9e3$var$queue.indexOf(job);
    if (index !== -1 && index > $84556724c483b9e3$var$lastFlushedIndex) $84556724c483b9e3$var$queue.splice(index, 1);
}
function $84556724c483b9e3$var$queueFlush() {
    if (!$84556724c483b9e3$var$flushing && !$84556724c483b9e3$var$flushPending) {
        $84556724c483b9e3$var$flushPending = true;
        queueMicrotask($84556724c483b9e3$var$flushJobs);
    }
}
function $84556724c483b9e3$var$flushJobs() {
    $84556724c483b9e3$var$flushPending = false;
    $84556724c483b9e3$var$flushing = true;
    for(let i = 0; i < $84556724c483b9e3$var$queue.length; i++){
        $84556724c483b9e3$var$queue[i]();
        $84556724c483b9e3$var$lastFlushedIndex = i;
    }
    $84556724c483b9e3$var$queue.length = 0;
    $84556724c483b9e3$var$lastFlushedIndex = -1;
    $84556724c483b9e3$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $84556724c483b9e3$var$reactive;
var $84556724c483b9e3$var$effect;
var $84556724c483b9e3$var$release;
var $84556724c483b9e3$var$raw;
var $84556724c483b9e3$var$shouldSchedule = true;
function $84556724c483b9e3$var$disableEffectScheduling(callback) {
    $84556724c483b9e3$var$shouldSchedule = false;
    callback();
    $84556724c483b9e3$var$shouldSchedule = true;
}
function $84556724c483b9e3$var$setReactivityEngine(engine) {
    $84556724c483b9e3$var$reactive = engine.reactive;
    $84556724c483b9e3$var$release = engine.release;
    $84556724c483b9e3$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($84556724c483b9e3$var$shouldSchedule) $84556724c483b9e3$var$scheduler(task);
                else task();
            }
        });
    $84556724c483b9e3$var$raw = engine.raw;
}
function $84556724c483b9e3$var$overrideEffect(override) {
    $84556724c483b9e3$var$effect = override;
}
function $84556724c483b9e3$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $84556724c483b9e3$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $84556724c483b9e3$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $84556724c483b9e3$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $84556724c483b9e3$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$84556724c483b9e3$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $84556724c483b9e3$var$onAttributeAddeds = [];
var $84556724c483b9e3$var$onElRemoveds = [];
var $84556724c483b9e3$var$onElAddeds = [];
function $84556724c483b9e3$var$onElAdded(callback) {
    $84556724c483b9e3$var$onElAddeds.push(callback);
}
function $84556724c483b9e3$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $84556724c483b9e3$var$onElRemoveds.push(callback);
    }
}
function $84556724c483b9e3$var$onAttributesAdded(callback) {
    $84556724c483b9e3$var$onAttributeAddeds.push(callback);
}
function $84556724c483b9e3$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $84556724c483b9e3$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $84556724c483b9e3$var$cleanupElement(el) {
    el._x_effects?.forEach($84556724c483b9e3$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $84556724c483b9e3$var$observer = new MutationObserver($84556724c483b9e3$var$onMutate);
var $84556724c483b9e3$var$currentlyObserving = false;
function $84556724c483b9e3$var$startObservingMutations() {
    $84556724c483b9e3$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $84556724c483b9e3$var$currentlyObserving = true;
}
function $84556724c483b9e3$var$stopObservingMutations() {
    $84556724c483b9e3$var$flushObserver();
    $84556724c483b9e3$var$observer.disconnect();
    $84556724c483b9e3$var$currentlyObserving = false;
}
var $84556724c483b9e3$var$queuedMutations = [];
function $84556724c483b9e3$var$flushObserver() {
    let records = $84556724c483b9e3$var$observer.takeRecords();
    $84556724c483b9e3$var$queuedMutations.push(()=>records.length > 0 && $84556724c483b9e3$var$onMutate(records));
    let queueLengthWhenTriggered = $84556724c483b9e3$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($84556724c483b9e3$var$queuedMutations.length === queueLengthWhenTriggered) while($84556724c483b9e3$var$queuedMutations.length > 0)$84556724c483b9e3$var$queuedMutations.shift()();
    });
}
function $84556724c483b9e3$var$mutateDom(callback) {
    if (!$84556724c483b9e3$var$currentlyObserving) return callback();
    $84556724c483b9e3$var$stopObservingMutations();
    let result = callback();
    $84556724c483b9e3$var$startObservingMutations();
    return result;
}
var $84556724c483b9e3$var$isCollecting = false;
var $84556724c483b9e3$var$deferredMutations = [];
function $84556724c483b9e3$var$deferMutations() {
    $84556724c483b9e3$var$isCollecting = true;
}
function $84556724c483b9e3$var$flushAndStopDeferringMutations() {
    $84556724c483b9e3$var$isCollecting = false;
    $84556724c483b9e3$var$onMutate($84556724c483b9e3$var$deferredMutations);
    $84556724c483b9e3$var$deferredMutations = [];
}
function $84556724c483b9e3$var$onMutate(mutations) {
    if ($84556724c483b9e3$var$isCollecting) {
        $84556724c483b9e3$var$deferredMutations = $84556724c483b9e3$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $84556724c483b9e3$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $84556724c483b9e3$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $84556724c483b9e3$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $84556724c483b9e3$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $84556724c483b9e3$var$scope(node) {
    return $84556724c483b9e3$var$mergeProxies($84556724c483b9e3$var$closestDataStack(node));
}
function $84556724c483b9e3$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$84556724c483b9e3$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $84556724c483b9e3$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $84556724c483b9e3$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $84556724c483b9e3$var$closestDataStack(node.parentNode);
}
function $84556724c483b9e3$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $84556724c483b9e3$var$mergeProxyTrap);
}
var $84556724c483b9e3$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $84556724c483b9e3$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $84556724c483b9e3$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $84556724c483b9e3$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $84556724c483b9e3$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$84556724c483b9e3$var$get(data2, path), (value)=>$84556724c483b9e3$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $84556724c483b9e3$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $84556724c483b9e3$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $84556724c483b9e3$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $84556724c483b9e3$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $84556724c483b9e3$var$magics = {};
function $84556724c483b9e3$var$magic(name, callback) {
    $84556724c483b9e3$var$magics[name] = callback;
}
function $84556724c483b9e3$var$injectMagics(obj, el) {
    let memoizedUtilities = $84556724c483b9e3$var$getUtilities(el);
    Object.entries($84556724c483b9e3$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $84556724c483b9e3$var$getUtilities(el) {
    let [utilities, cleanup2] = $84556724c483b9e3$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $84556724c483b9e3$var$interceptor,
        ...utilities
    };
    $84556724c483b9e3$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $84556724c483b9e3$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $84556724c483b9e3$var$handleError(e, el, expression);
    }
}
function $84556724c483b9e3$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $84556724c483b9e3$var$shouldAutoEvaluateFunctions = true;
function $84556724c483b9e3$var$dontAutoEvaluateFunctions(callback) {
    let cache = $84556724c483b9e3$var$shouldAutoEvaluateFunctions;
    $84556724c483b9e3$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $84556724c483b9e3$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $84556724c483b9e3$var$evaluate(el, expression, extras = {}) {
    let result;
    $84556724c483b9e3$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $84556724c483b9e3$var$evaluateLater(...args) {
    return $84556724c483b9e3$var$theEvaluatorFunction(...args);
}
var $84556724c483b9e3$var$theEvaluatorFunction = $84556724c483b9e3$var$normalEvaluator;
function $84556724c483b9e3$var$setEvaluator(newEvaluator) {
    $84556724c483b9e3$var$theEvaluatorFunction = newEvaluator;
}
function $84556724c483b9e3$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $84556724c483b9e3$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$84556724c483b9e3$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $84556724c483b9e3$var$generateEvaluatorFromFunction(dataStack, expression) : $84556724c483b9e3$var$generateEvaluatorFromString(dataStack, expression, el);
    return $84556724c483b9e3$var$tryCatch.bind(null, el, expression, evaluator);
}
function $84556724c483b9e3$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($84556724c483b9e3$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $84556724c483b9e3$var$runIfTypeOfFunction(receiver, result);
    };
}
var $84556724c483b9e3$var$evaluatorMemo = {};
function $84556724c483b9e3$var$generateFunctionFromString(expression, el) {
    if ($84556724c483b9e3$var$evaluatorMemo[expression]) return $84556724c483b9e3$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $84556724c483b9e3$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $84556724c483b9e3$var$evaluatorMemo[expression] = func;
    return func;
}
function $84556724c483b9e3$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $84556724c483b9e3$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $84556724c483b9e3$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$84556724c483b9e3$var$handleError(error2, el, expression));
            if (func.finished) {
                $84556724c483b9e3$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $84556724c483b9e3$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$84556724c483b9e3$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $84556724c483b9e3$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($84556724c483b9e3$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$84556724c483b9e3$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$84556724c483b9e3$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $84556724c483b9e3$var$prefixAsString = "x-";
function $84556724c483b9e3$var$prefix(subject = "") {
    return $84556724c483b9e3$var$prefixAsString + subject;
}
function $84556724c483b9e3$var$setPrefix(newPrefix) {
    $84556724c483b9e3$var$prefixAsString = newPrefix;
}
var $84556724c483b9e3$var$directiveHandlers = {};
function $84556724c483b9e3$var$directive(name, callback) {
    $84556724c483b9e3$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$84556724c483b9e3$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $84556724c483b9e3$var$directiveOrder.indexOf(directive2);
            $84556724c483b9e3$var$directiveOrder.splice(pos >= 0 ? pos : $84556724c483b9e3$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $84556724c483b9e3$var$directiveExists(name) {
    return Object.keys($84556724c483b9e3$var$directiveHandlers).includes(name);
}
function $84556724c483b9e3$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $84556724c483b9e3$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($84556724c483b9e3$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($84556724c483b9e3$var$outNonAlpineAttributes).map($84556724c483b9e3$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($84556724c483b9e3$var$byPriority);
    return directives2.map((directive2)=>{
        return $84556724c483b9e3$var$getDirectiveHandler(el, directive2);
    });
}
function $84556724c483b9e3$var$attributesOnly(attributes) {
    return Array.from(attributes).map($84556724c483b9e3$var$toTransformedAttributes()).filter((attr)=>!$84556724c483b9e3$var$outNonAlpineAttributes(attr));
}
var $84556724c483b9e3$var$isDeferringHandlers = false;
var $84556724c483b9e3$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $84556724c483b9e3$var$currentHandlerStackKey = Symbol();
function $84556724c483b9e3$var$deferHandlingDirectives(callback) {
    $84556724c483b9e3$var$isDeferringHandlers = true;
    let key = Symbol();
    $84556724c483b9e3$var$currentHandlerStackKey = key;
    $84556724c483b9e3$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($84556724c483b9e3$var$directiveHandlerStacks.get(key).length)$84556724c483b9e3$var$directiveHandlerStacks.get(key).shift()();
        $84556724c483b9e3$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $84556724c483b9e3$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $84556724c483b9e3$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $84556724c483b9e3$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $84556724c483b9e3$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $84556724c483b9e3$var$evaluateLater.bind($84556724c483b9e3$var$evaluateLater, el),
        evaluate: $84556724c483b9e3$var$evaluate.bind($84556724c483b9e3$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $84556724c483b9e3$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $84556724c483b9e3$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $84556724c483b9e3$var$getElementBoundUtilities(el);
    $84556724c483b9e3$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $84556724c483b9e3$var$isDeferringHandlers ? $84556724c483b9e3$var$directiveHandlerStacks.get($84556724c483b9e3$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $84556724c483b9e3$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $84556724c483b9e3$var$into = (i)=>i;
function $84556724c483b9e3$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $84556724c483b9e3$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $84556724c483b9e3$var$attributeTransformers = [];
function $84556724c483b9e3$var$mapAttributes(callback) {
    $84556724c483b9e3$var$attributeTransformers.push(callback);
}
function $84556724c483b9e3$var$outNonAlpineAttributes({ name: name }) {
    return $84556724c483b9e3$var$alpineAttributeRegex().test(name);
}
var $84556724c483b9e3$var$alpineAttributeRegex = ()=>new RegExp(`^${$84556724c483b9e3$var$prefixAsString}([^:^.]+)\\b`);
function $84556724c483b9e3$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($84556724c483b9e3$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $84556724c483b9e3$var$DEFAULT = "DEFAULT";
var $84556724c483b9e3$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $84556724c483b9e3$var$DEFAULT,
    "teleport"
];
function $84556724c483b9e3$var$byPriority(a, b) {
    let typeA = $84556724c483b9e3$var$directiveOrder.indexOf(a.type) === -1 ? $84556724c483b9e3$var$DEFAULT : a.type;
    let typeB = $84556724c483b9e3$var$directiveOrder.indexOf(b.type) === -1 ? $84556724c483b9e3$var$DEFAULT : b.type;
    return $84556724c483b9e3$var$directiveOrder.indexOf(typeA) - $84556724c483b9e3$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $84556724c483b9e3$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $84556724c483b9e3$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$84556724c483b9e3$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $84556724c483b9e3$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $84556724c483b9e3$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $84556724c483b9e3$var$started = false;
function $84556724c483b9e3$var$start() {
    if ($84556724c483b9e3$var$started) $84556724c483b9e3$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $84556724c483b9e3$var$started = true;
    if (!document.body) $84556724c483b9e3$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $84556724c483b9e3$var$dispatch(document, "alpine:init");
    $84556724c483b9e3$var$dispatch(document, "alpine:initializing");
    $84556724c483b9e3$var$startObservingMutations();
    $84556724c483b9e3$var$onElAdded((el)=>$84556724c483b9e3$var$initTree(el, $84556724c483b9e3$var$walk));
    $84556724c483b9e3$var$onElRemoved((el)=>$84556724c483b9e3$var$destroyTree(el));
    $84556724c483b9e3$var$onAttributesAdded((el, attrs)=>{
        $84556724c483b9e3$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$84556724c483b9e3$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($84556724c483b9e3$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $84556724c483b9e3$var$initTree(el);
    });
    $84556724c483b9e3$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $84556724c483b9e3$var$warnAboutMissingPlugins();
    });
}
var $84556724c483b9e3$var$rootSelectorCallbacks = [];
var $84556724c483b9e3$var$initSelectorCallbacks = [];
function $84556724c483b9e3$var$rootSelectors() {
    return $84556724c483b9e3$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $84556724c483b9e3$var$allSelectors() {
    return $84556724c483b9e3$var$rootSelectorCallbacks.concat($84556724c483b9e3$var$initSelectorCallbacks).map((fn)=>fn());
}
function $84556724c483b9e3$var$addRootSelector(selectorCallback) {
    $84556724c483b9e3$var$rootSelectorCallbacks.push(selectorCallback);
}
function $84556724c483b9e3$var$addInitSelector(selectorCallback) {
    $84556724c483b9e3$var$initSelectorCallbacks.push(selectorCallback);
}
function $84556724c483b9e3$var$closestRoot(el, includeInitSelectors = false) {
    return $84556724c483b9e3$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $84556724c483b9e3$var$allSelectors() : $84556724c483b9e3$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $84556724c483b9e3$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $84556724c483b9e3$var$findClosest(el.parentElement, callback);
}
function $84556724c483b9e3$var$isRoot(el) {
    return $84556724c483b9e3$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $84556724c483b9e3$var$initInterceptors2 = [];
function $84556724c483b9e3$var$interceptInit(callback) {
    $84556724c483b9e3$var$initInterceptors2.push(callback);
}
var $84556724c483b9e3$var$markerDispenser = 1;
function $84556724c483b9e3$var$initTree(el, walker = $84556724c483b9e3$var$walk, intercept = ()=>{}) {
    if ($84556724c483b9e3$var$findClosest(el, (i)=>i._x_ignore)) return;
    $84556724c483b9e3$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $84556724c483b9e3$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $84556724c483b9e3$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $84556724c483b9e3$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $84556724c483b9e3$var$destroyTree(root, walker = $84556724c483b9e3$var$walk) {
    walker(root, (el)=>{
        $84556724c483b9e3$var$cleanupElement(el);
        $84556724c483b9e3$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $84556724c483b9e3$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($84556724c483b9e3$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $84556724c483b9e3$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $84556724c483b9e3$var$tickStack = [];
var $84556724c483b9e3$var$isHolding = false;
function $84556724c483b9e3$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $84556724c483b9e3$var$isHolding || setTimeout(()=>{
            $84556724c483b9e3$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $84556724c483b9e3$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $84556724c483b9e3$var$releaseNextTicks() {
    $84556724c483b9e3$var$isHolding = false;
    while($84556724c483b9e3$var$tickStack.length)$84556724c483b9e3$var$tickStack.shift()();
}
function $84556724c483b9e3$var$holdNextTicks() {
    $84556724c483b9e3$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $84556724c483b9e3$var$setClasses(el, value) {
    if (Array.isArray(value)) return $84556724c483b9e3$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $84556724c483b9e3$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $84556724c483b9e3$var$setClasses(el, value());
    return $84556724c483b9e3$var$setClassesFromString(el, value);
}
function $84556724c483b9e3$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $84556724c483b9e3$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $84556724c483b9e3$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $84556724c483b9e3$var$setStylesFromObject(el, value);
    return $84556724c483b9e3$var$setStylesFromString(el, value);
}
function $84556724c483b9e3$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $84556724c483b9e3$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $84556724c483b9e3$var$setStyles(el, previousStyles);
    };
}
function $84556724c483b9e3$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $84556724c483b9e3$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $84556724c483b9e3$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$84556724c483b9e3$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $84556724c483b9e3$var$registerTransitionsFromHelper(el, modifiers, value);
    else $84556724c483b9e3$var$registerTransitionsFromClassString(el, expression, value);
});
function $84556724c483b9e3$var$registerTransitionsFromClassString(el, classString, stage) {
    $84556724c483b9e3$var$registerTransitionObject(el, $84556724c483b9e3$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $84556724c483b9e3$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $84556724c483b9e3$var$registerTransitionObject(el, $84556724c483b9e3$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $84556724c483b9e3$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $84556724c483b9e3$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $84556724c483b9e3$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $84556724c483b9e3$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $84556724c483b9e3$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $84556724c483b9e3$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $84556724c483b9e3$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $84556724c483b9e3$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $84556724c483b9e3$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $84556724c483b9e3$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $84556724c483b9e3$var$closestHide(parent);
}
function $84556724c483b9e3$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $84556724c483b9e3$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $84556724c483b9e3$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $84556724c483b9e3$var$once(()=>{
        $84556724c483b9e3$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $84556724c483b9e3$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $84556724c483b9e3$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $84556724c483b9e3$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $84556724c483b9e3$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $84556724c483b9e3$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $84556724c483b9e3$var$mutateDom(()=>{
                stages.end();
            });
            $84556724c483b9e3$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $84556724c483b9e3$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $84556724c483b9e3$var$isCloning = false;
function $84556724c483b9e3$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$84556724c483b9e3$var$isCloning ? fallback(...args) : callback(...args);
}
function $84556724c483b9e3$var$onlyDuringClone(callback) {
    return (...args)=>$84556724c483b9e3$var$isCloning && callback(...args);
}
var $84556724c483b9e3$var$interceptors = [];
function $84556724c483b9e3$var$interceptClone(callback) {
    $84556724c483b9e3$var$interceptors.push(callback);
}
function $84556724c483b9e3$var$cloneNode(from, to) {
    $84556724c483b9e3$var$interceptors.forEach((i)=>i(from, to));
    $84556724c483b9e3$var$isCloning = true;
    $84556724c483b9e3$var$dontRegisterReactiveSideEffects(()=>{
        $84556724c483b9e3$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $84556724c483b9e3$var$isCloning = false;
}
var $84556724c483b9e3$var$isCloningLegacy = false;
function $84556724c483b9e3$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $84556724c483b9e3$var$isCloning = true;
    $84556724c483b9e3$var$isCloningLegacy = true;
    $84556724c483b9e3$var$dontRegisterReactiveSideEffects(()=>{
        $84556724c483b9e3$var$cloneTree(newEl);
    });
    $84556724c483b9e3$var$isCloning = false;
    $84556724c483b9e3$var$isCloningLegacy = false;
}
function $84556724c483b9e3$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $84556724c483b9e3$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $84556724c483b9e3$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $84556724c483b9e3$var$initTree(el, shallowWalker);
}
function $84556724c483b9e3$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $84556724c483b9e3$var$effect;
    $84556724c483b9e3$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $84556724c483b9e3$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $84556724c483b9e3$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $84556724c483b9e3$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $84556724c483b9e3$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $84556724c483b9e3$var$camelCase(name) : name;
    switch(name){
        case "value":
            $84556724c483b9e3$var$bindInputValue(el, value);
            break;
        case "style":
            $84556724c483b9e3$var$bindStyles(el, value);
            break;
        case "class":
            $84556724c483b9e3$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $84556724c483b9e3$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $84556724c483b9e3$var$bindAttribute(el, name, value);
            break;
    }
}
function $84556724c483b9e3$var$bindInputValue(el, value) {
    if ($84556724c483b9e3$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $84556724c483b9e3$var$safeParseBoolean(el.value) === value;
            else el.checked = $84556724c483b9e3$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($84556724c483b9e3$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$84556724c483b9e3$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $84556724c483b9e3$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $84556724c483b9e3$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $84556724c483b9e3$var$setClasses(el, value);
}
function $84556724c483b9e3$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $84556724c483b9e3$var$setStyles(el, value);
}
function $84556724c483b9e3$var$bindAttributeAndProperty(el, name, value) {
    $84556724c483b9e3$var$bindAttribute(el, name, value);
    $84556724c483b9e3$var$setPropertyIfChanged(el, name, value);
}
function $84556724c483b9e3$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $84556724c483b9e3$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($84556724c483b9e3$var$isBooleanAttr(name)) value = name;
        $84556724c483b9e3$var$setIfChanged(el, name, value);
    }
}
function $84556724c483b9e3$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $84556724c483b9e3$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $84556724c483b9e3$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $84556724c483b9e3$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $84556724c483b9e3$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $84556724c483b9e3$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $84556724c483b9e3$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $84556724c483b9e3$var$isBooleanAttr(attrName) {
    return $84556724c483b9e3$var$booleanAttributes.has(attrName);
}
function $84556724c483b9e3$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $84556724c483b9e3$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $84556724c483b9e3$var$getAttributeBinding(el, name, fallback);
}
function $84556724c483b9e3$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $84556724c483b9e3$var$dontAutoEvaluateFunctions(()=>{
            return $84556724c483b9e3$var$evaluate(el, binding.expression);
        });
    }
    return $84556724c483b9e3$var$getAttributeBinding(el, name, fallback);
}
function $84556724c483b9e3$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($84556724c483b9e3$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $84556724c483b9e3$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $84556724c483b9e3$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $84556724c483b9e3$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $84556724c483b9e3$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $84556724c483b9e3$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $84556724c483b9e3$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($84556724c483b9e3$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($84556724c483b9e3$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($84556724c483b9e3$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $84556724c483b9e3$var$release(reference);
    };
}
function $84556724c483b9e3$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $84556724c483b9e3$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($84556724c483b9e3$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $84556724c483b9e3$var$stores = {};
var $84556724c483b9e3$var$isReactive = false;
function $84556724c483b9e3$var$store(name, value) {
    if (!$84556724c483b9e3$var$isReactive) {
        $84556724c483b9e3$var$stores = $84556724c483b9e3$var$reactive($84556724c483b9e3$var$stores);
        $84556724c483b9e3$var$isReactive = true;
    }
    if (value === void 0) return $84556724c483b9e3$var$stores[name];
    $84556724c483b9e3$var$stores[name] = value;
    $84556724c483b9e3$var$initInterceptors($84556724c483b9e3$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $84556724c483b9e3$var$stores[name].init();
}
function $84556724c483b9e3$var$getStores() {
    return $84556724c483b9e3$var$stores;
}
// packages/alpinejs/src/binds.js
var $84556724c483b9e3$var$binds = {};
function $84556724c483b9e3$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $84556724c483b9e3$var$applyBindingsObject(name, getBindings());
    else $84556724c483b9e3$var$binds[name] = getBindings;
    return ()=>{};
}
function $84556724c483b9e3$var$injectBindingProviders(obj) {
    Object.entries($84556724c483b9e3$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $84556724c483b9e3$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $84556724c483b9e3$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $84556724c483b9e3$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $84556724c483b9e3$var$datas = {};
function $84556724c483b9e3$var$data(name, callback) {
    $84556724c483b9e3$var$datas[name] = callback;
}
function $84556724c483b9e3$var$injectDataProviders(obj, context) {
    Object.entries($84556724c483b9e3$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $84556724c483b9e3$var$Alpine = {
    get reactive () {
        return $84556724c483b9e3$var$reactive;
    },
    get release () {
        return $84556724c483b9e3$var$release;
    },
    get effect () {
        return $84556724c483b9e3$var$effect;
    },
    get raw () {
        return $84556724c483b9e3$var$raw;
    },
    version: "3.14.9",
    flushAndStopDeferringMutations: $84556724c483b9e3$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $84556724c483b9e3$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $84556724c483b9e3$var$disableEffectScheduling,
    startObservingMutations: $84556724c483b9e3$var$startObservingMutations,
    stopObservingMutations: $84556724c483b9e3$var$stopObservingMutations,
    setReactivityEngine: $84556724c483b9e3$var$setReactivityEngine,
    onAttributeRemoved: $84556724c483b9e3$var$onAttributeRemoved,
    onAttributesAdded: $84556724c483b9e3$var$onAttributesAdded,
    closestDataStack: $84556724c483b9e3$var$closestDataStack,
    skipDuringClone: $84556724c483b9e3$var$skipDuringClone,
    onlyDuringClone: $84556724c483b9e3$var$onlyDuringClone,
    addRootSelector: $84556724c483b9e3$var$addRootSelector,
    addInitSelector: $84556724c483b9e3$var$addInitSelector,
    interceptClone: $84556724c483b9e3$var$interceptClone,
    addScopeToNode: $84556724c483b9e3$var$addScopeToNode,
    deferMutations: $84556724c483b9e3$var$deferMutations,
    mapAttributes: $84556724c483b9e3$var$mapAttributes,
    evaluateLater: $84556724c483b9e3$var$evaluateLater,
    interceptInit: $84556724c483b9e3$var$interceptInit,
    setEvaluator: $84556724c483b9e3$var$setEvaluator,
    mergeProxies: $84556724c483b9e3$var$mergeProxies,
    extractProp: $84556724c483b9e3$var$extractProp,
    findClosest: $84556724c483b9e3$var$findClosest,
    onElRemoved: $84556724c483b9e3$var$onElRemoved,
    closestRoot: $84556724c483b9e3$var$closestRoot,
    destroyTree: $84556724c483b9e3$var$destroyTree,
    interceptor: $84556724c483b9e3$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $84556724c483b9e3$var$transition,
    setStyles: // INTERNAL
    $84556724c483b9e3$var$setStyles,
    mutateDom: // INTERNAL
    $84556724c483b9e3$var$mutateDom,
    directive: $84556724c483b9e3$var$directive,
    entangle: $84556724c483b9e3$var$entangle,
    throttle: $84556724c483b9e3$var$throttle,
    debounce: $84556724c483b9e3$var$debounce,
    evaluate: $84556724c483b9e3$var$evaluate,
    initTree: $84556724c483b9e3$var$initTree,
    nextTick: $84556724c483b9e3$var$nextTick,
    prefixed: $84556724c483b9e3$var$prefix,
    prefix: $84556724c483b9e3$var$setPrefix,
    plugin: $84556724c483b9e3$var$plugin,
    magic: $84556724c483b9e3$var$magic,
    store: $84556724c483b9e3$var$store,
    start: $84556724c483b9e3$var$start,
    clone: $84556724c483b9e3$var$clone,
    cloneNode: // INTERNAL
    $84556724c483b9e3$var$cloneNode,
    // INTERNAL
    bound: $84556724c483b9e3$var$getBinding,
    $data: $84556724c483b9e3$var$scope,
    watch: $84556724c483b9e3$var$watch,
    walk: $84556724c483b9e3$var$walk,
    data: $84556724c483b9e3$var$data,
    bind: $84556724c483b9e3$var$bind2
};
var $84556724c483b9e3$var$alpine_default = $84556724c483b9e3$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $84556724c483b9e3$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $84556724c483b9e3$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $84556724c483b9e3$var$isBooleanAttr2 = /* @__PURE__ */ $84556724c483b9e3$var$makeMap($84556724c483b9e3$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $84556724c483b9e3$var$EMPTY_OBJ = Object.freeze({});
var $84556724c483b9e3$var$EMPTY_ARR = Object.freeze([]);
var $84556724c483b9e3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $84556724c483b9e3$var$hasOwn = (val, key)=>$84556724c483b9e3$var$hasOwnProperty.call(val, key);
var $84556724c483b9e3$var$isArray = Array.isArray;
var $84556724c483b9e3$var$isMap = (val)=>$84556724c483b9e3$var$toTypeString(val) === "[object Map]";
var $84556724c483b9e3$var$isString = (val)=>typeof val === "string";
var $84556724c483b9e3$var$isSymbol = (val)=>typeof val === "symbol";
var $84556724c483b9e3$var$isObject = (val)=>val !== null && typeof val === "object";
var $84556724c483b9e3$var$objectToString = Object.prototype.toString;
var $84556724c483b9e3$var$toTypeString = (value)=>$84556724c483b9e3$var$objectToString.call(value);
var $84556724c483b9e3$var$toRawType = (value)=>{
    return $84556724c483b9e3$var$toTypeString(value).slice(8, -1);
};
var $84556724c483b9e3$var$isIntegerKey = (key)=>$84556724c483b9e3$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $84556724c483b9e3$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $84556724c483b9e3$var$camelizeRE = /-(\w)/g;
var $84556724c483b9e3$var$camelize = $84556724c483b9e3$var$cacheStringFunction((str)=>{
    return str.replace($84556724c483b9e3$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $84556724c483b9e3$var$hyphenateRE = /\B([A-Z])/g;
var $84556724c483b9e3$var$hyphenate = $84556724c483b9e3$var$cacheStringFunction((str)=>str.replace($84556724c483b9e3$var$hyphenateRE, "-$1").toLowerCase());
var $84556724c483b9e3$var$capitalize = $84556724c483b9e3$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $84556724c483b9e3$var$toHandlerKey = $84556724c483b9e3$var$cacheStringFunction((str)=>str ? `on${$84556724c483b9e3$var$capitalize(str)}` : ``);
var $84556724c483b9e3$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $84556724c483b9e3$var$targetMap = /* @__PURE__ */ new WeakMap();
var $84556724c483b9e3$var$effectStack = [];
var $84556724c483b9e3$var$activeEffect;
var $84556724c483b9e3$var$ITERATE_KEY = Symbol("iterate");
var $84556724c483b9e3$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $84556724c483b9e3$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $84556724c483b9e3$var$effect2(fn, options = $84556724c483b9e3$var$EMPTY_OBJ) {
    if ($84556724c483b9e3$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $84556724c483b9e3$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $84556724c483b9e3$var$stop(effect3) {
    if (effect3.active) {
        $84556724c483b9e3$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $84556724c483b9e3$var$uid = 0;
function $84556724c483b9e3$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$84556724c483b9e3$var$effectStack.includes(effect3)) {
            $84556724c483b9e3$var$cleanup(effect3);
            try {
                $84556724c483b9e3$var$enableTracking();
                $84556724c483b9e3$var$effectStack.push(effect3);
                $84556724c483b9e3$var$activeEffect = effect3;
                return fn();
            } finally{
                $84556724c483b9e3$var$effectStack.pop();
                $84556724c483b9e3$var$resetTracking();
                $84556724c483b9e3$var$activeEffect = $84556724c483b9e3$var$effectStack[$84556724c483b9e3$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $84556724c483b9e3$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $84556724c483b9e3$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $84556724c483b9e3$var$shouldTrack = true;
var $84556724c483b9e3$var$trackStack = [];
function $84556724c483b9e3$var$pauseTracking() {
    $84556724c483b9e3$var$trackStack.push($84556724c483b9e3$var$shouldTrack);
    $84556724c483b9e3$var$shouldTrack = false;
}
function $84556724c483b9e3$var$enableTracking() {
    $84556724c483b9e3$var$trackStack.push($84556724c483b9e3$var$shouldTrack);
    $84556724c483b9e3$var$shouldTrack = true;
}
function $84556724c483b9e3$var$resetTracking() {
    const last = $84556724c483b9e3$var$trackStack.pop();
    $84556724c483b9e3$var$shouldTrack = last === void 0 ? true : last;
}
function $84556724c483b9e3$var$track(target, type, key) {
    if (!$84556724c483b9e3$var$shouldTrack || $84556724c483b9e3$var$activeEffect === void 0) return;
    let depsMap = $84556724c483b9e3$var$targetMap.get(target);
    if (!depsMap) $84556724c483b9e3$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($84556724c483b9e3$var$activeEffect)) {
        dep.add($84556724c483b9e3$var$activeEffect);
        $84556724c483b9e3$var$activeEffect.deps.push(dep);
        if ($84556724c483b9e3$var$activeEffect.options.onTrack) $84556724c483b9e3$var$activeEffect.options.onTrack({
            effect: $84556724c483b9e3$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $84556724c483b9e3$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $84556724c483b9e3$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $84556724c483b9e3$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $84556724c483b9e3$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$84556724c483b9e3$var$isArray(target)) {
                    add2(depsMap.get($84556724c483b9e3$var$ITERATE_KEY));
                    if ($84556724c483b9e3$var$isMap(target)) add2(depsMap.get($84556724c483b9e3$var$MAP_KEY_ITERATE_KEY));
                } else if ($84556724c483b9e3$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$84556724c483b9e3$var$isArray(target)) {
                    add2(depsMap.get($84556724c483b9e3$var$ITERATE_KEY));
                    if ($84556724c483b9e3$var$isMap(target)) add2(depsMap.get($84556724c483b9e3$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($84556724c483b9e3$var$isMap(target)) add2(depsMap.get($84556724c483b9e3$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $84556724c483b9e3$var$isNonTrackableKeys = /* @__PURE__ */ $84556724c483b9e3$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $84556724c483b9e3$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($84556724c483b9e3$var$isSymbol));
var $84556724c483b9e3$var$get2 = /* @__PURE__ */ $84556724c483b9e3$var$createGetter();
var $84556724c483b9e3$var$readonlyGet = /* @__PURE__ */ $84556724c483b9e3$var$createGetter(true);
var $84556724c483b9e3$var$arrayInstrumentations = /* @__PURE__ */ $84556724c483b9e3$var$createArrayInstrumentations();
function $84556724c483b9e3$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $84556724c483b9e3$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$84556724c483b9e3$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($84556724c483b9e3$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $84556724c483b9e3$var$pauseTracking();
            const res = $84556724c483b9e3$var$toRaw(this)[key].apply(this, args);
            $84556724c483b9e3$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $84556724c483b9e3$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $84556724c483b9e3$var$shallowReadonlyMap : $84556724c483b9e3$var$readonlyMap : shallow ? $84556724c483b9e3$var$shallowReactiveMap : $84556724c483b9e3$var$reactiveMap).get(target)) return target;
        const targetIsArray = $84556724c483b9e3$var$isArray(target);
        if (!isReadonly && targetIsArray && $84556724c483b9e3$var$hasOwn($84556724c483b9e3$var$arrayInstrumentations, key)) return Reflect.get($84556724c483b9e3$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($84556724c483b9e3$var$isSymbol(key) ? $84556724c483b9e3$var$builtInSymbols.has(key) : $84556724c483b9e3$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $84556724c483b9e3$var$track(target, "get", key);
        if (shallow) return res;
        if ($84556724c483b9e3$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$84556724c483b9e3$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($84556724c483b9e3$var$isObject(res)) return isReadonly ? $84556724c483b9e3$var$readonly(res) : $84556724c483b9e3$var$reactive2(res);
        return res;
    };
}
var $84556724c483b9e3$var$set2 = /* @__PURE__ */ $84556724c483b9e3$var$createSetter();
function $84556724c483b9e3$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $84556724c483b9e3$var$toRaw(value);
            oldValue = $84556724c483b9e3$var$toRaw(oldValue);
            if (!$84556724c483b9e3$var$isArray(target) && $84556724c483b9e3$var$isRef(oldValue) && !$84556724c483b9e3$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $84556724c483b9e3$var$isArray(target) && $84556724c483b9e3$var$isIntegerKey(key) ? Number(key) < target.length : $84556724c483b9e3$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $84556724c483b9e3$var$toRaw(receiver)) {
            if (!hadKey) $84556724c483b9e3$var$trigger(target, "add", key, value);
            else if ($84556724c483b9e3$var$hasChanged(value, oldValue)) $84556724c483b9e3$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $84556724c483b9e3$var$deleteProperty(target, key) {
    const hadKey = $84556724c483b9e3$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $84556724c483b9e3$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $84556724c483b9e3$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$84556724c483b9e3$var$isSymbol(key) || !$84556724c483b9e3$var$builtInSymbols.has(key)) $84556724c483b9e3$var$track(target, "has", key);
    return result;
}
function $84556724c483b9e3$var$ownKeys(target) {
    $84556724c483b9e3$var$track(target, "iterate", $84556724c483b9e3$var$isArray(target) ? "length" : $84556724c483b9e3$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $84556724c483b9e3$var$mutableHandlers = {
    get: $84556724c483b9e3$var$get2,
    set: $84556724c483b9e3$var$set2,
    deleteProperty: $84556724c483b9e3$var$deleteProperty,
    has: $84556724c483b9e3$var$has,
    ownKeys: $84556724c483b9e3$var$ownKeys
};
var $84556724c483b9e3$var$readonlyHandlers = {
    get: $84556724c483b9e3$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $84556724c483b9e3$var$toReactive = (value)=>$84556724c483b9e3$var$isObject(value) ? $84556724c483b9e3$var$reactive2(value) : value;
var $84556724c483b9e3$var$toReadonly = (value)=>$84556724c483b9e3$var$isObject(value) ? $84556724c483b9e3$var$readonly(value) : value;
var $84556724c483b9e3$var$toShallow = (value)=>value;
var $84556724c483b9e3$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $84556724c483b9e3$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $84556724c483b9e3$var$toRaw(target);
    const rawKey = $84556724c483b9e3$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $84556724c483b9e3$var$track(rawTarget, "get", key);
    !isReadonly && $84556724c483b9e3$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $84556724c483b9e3$var$getProto(rawTarget);
    const wrap = isShallow ? $84556724c483b9e3$var$toShallow : isReadonly ? $84556724c483b9e3$var$toReadonly : $84556724c483b9e3$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $84556724c483b9e3$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $84556724c483b9e3$var$toRaw(target);
    const rawKey = $84556724c483b9e3$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $84556724c483b9e3$var$track(rawTarget, "has", key);
    !isReadonly && $84556724c483b9e3$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $84556724c483b9e3$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $84556724c483b9e3$var$track($84556724c483b9e3$var$toRaw(target), "iterate", $84556724c483b9e3$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $84556724c483b9e3$var$add(value) {
    value = $84556724c483b9e3$var$toRaw(value);
    const target = $84556724c483b9e3$var$toRaw(this);
    const proto = $84556724c483b9e3$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $84556724c483b9e3$var$trigger(target, "add", value, value);
    }
    return this;
}
function $84556724c483b9e3$var$set$1(key, value) {
    value = $84556724c483b9e3$var$toRaw(value);
    const target = $84556724c483b9e3$var$toRaw(this);
    const { has: has2, get: get3 } = $84556724c483b9e3$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $84556724c483b9e3$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $84556724c483b9e3$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $84556724c483b9e3$var$trigger(target, "add", key, value);
    else if ($84556724c483b9e3$var$hasChanged(value, oldValue)) $84556724c483b9e3$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $84556724c483b9e3$var$deleteEntry(key) {
    const target = $84556724c483b9e3$var$toRaw(this);
    const { has: has2, get: get3 } = $84556724c483b9e3$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $84556724c483b9e3$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $84556724c483b9e3$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $84556724c483b9e3$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $84556724c483b9e3$var$clear() {
    const target = $84556724c483b9e3$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $84556724c483b9e3$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $84556724c483b9e3$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $84556724c483b9e3$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $84556724c483b9e3$var$toRaw(target);
        const wrap = isShallow ? $84556724c483b9e3$var$toShallow : isReadonly ? $84556724c483b9e3$var$toReadonly : $84556724c483b9e3$var$toReactive;
        !isReadonly && $84556724c483b9e3$var$track(rawTarget, "iterate", $84556724c483b9e3$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $84556724c483b9e3$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $84556724c483b9e3$var$toRaw(target);
        const targetIsMap = $84556724c483b9e3$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $84556724c483b9e3$var$toShallow : isReadonly ? $84556724c483b9e3$var$toReadonly : $84556724c483b9e3$var$toReactive;
        !isReadonly && $84556724c483b9e3$var$track(rawTarget, "iterate", isKeyOnly ? $84556724c483b9e3$var$MAP_KEY_ITERATE_KEY : $84556724c483b9e3$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $84556724c483b9e3$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$84556724c483b9e3$var$capitalize(type)} operation ${key}failed: target is readonly.`, $84556724c483b9e3$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $84556724c483b9e3$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $84556724c483b9e3$var$get$1(this, key);
        },
        get size () {
            return $84556724c483b9e3$var$size(this);
        },
        has: $84556724c483b9e3$var$has$1,
        add: $84556724c483b9e3$var$add,
        set: $84556724c483b9e3$var$set$1,
        delete: $84556724c483b9e3$var$deleteEntry,
        clear: $84556724c483b9e3$var$clear,
        forEach: $84556724c483b9e3$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $84556724c483b9e3$var$get$1(this, key, false, true);
        },
        get size () {
            return $84556724c483b9e3$var$size(this);
        },
        has: $84556724c483b9e3$var$has$1,
        add: $84556724c483b9e3$var$add,
        set: $84556724c483b9e3$var$set$1,
        delete: $84556724c483b9e3$var$deleteEntry,
        clear: $84556724c483b9e3$var$clear,
        forEach: $84556724c483b9e3$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $84556724c483b9e3$var$get$1(this, key, true);
        },
        get size () {
            return $84556724c483b9e3$var$size(this, true);
        },
        has (key) {
            return $84556724c483b9e3$var$has$1.call(this, key, true);
        },
        add: $84556724c483b9e3$var$createReadonlyMethod("add"),
        set: $84556724c483b9e3$var$createReadonlyMethod("set"),
        delete: $84556724c483b9e3$var$createReadonlyMethod("delete"),
        clear: $84556724c483b9e3$var$createReadonlyMethod("clear"),
        forEach: $84556724c483b9e3$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $84556724c483b9e3$var$get$1(this, key, true, true);
        },
        get size () {
            return $84556724c483b9e3$var$size(this, true);
        },
        has (key) {
            return $84556724c483b9e3$var$has$1.call(this, key, true);
        },
        add: $84556724c483b9e3$var$createReadonlyMethod("add"),
        set: $84556724c483b9e3$var$createReadonlyMethod("set"),
        delete: $84556724c483b9e3$var$createReadonlyMethod("delete"),
        clear: $84556724c483b9e3$var$createReadonlyMethod("clear"),
        forEach: $84556724c483b9e3$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $84556724c483b9e3$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $84556724c483b9e3$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $84556724c483b9e3$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $84556724c483b9e3$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$84556724c483b9e3$var$mutableInstrumentations, $84556724c483b9e3$var$readonlyInstrumentations, $84556724c483b9e3$var$shallowInstrumentations, $84556724c483b9e3$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $84556724c483b9e3$var$createInstrumentations();
function $84556724c483b9e3$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $84556724c483b9e3$var$shallowReadonlyInstrumentations : $84556724c483b9e3$var$shallowInstrumentations : isReadonly ? $84556724c483b9e3$var$readonlyInstrumentations : $84556724c483b9e3$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($84556724c483b9e3$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $84556724c483b9e3$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $84556724c483b9e3$var$createInstrumentationGetter(false, false)
};
var $84556724c483b9e3$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $84556724c483b9e3$var$createInstrumentationGetter(true, false)
};
function $84556724c483b9e3$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $84556724c483b9e3$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $84556724c483b9e3$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $84556724c483b9e3$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $84556724c483b9e3$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $84556724c483b9e3$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $84556724c483b9e3$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $84556724c483b9e3$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $84556724c483b9e3$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $84556724c483b9e3$var$targetTypeMap($84556724c483b9e3$var$toRawType(value));
}
function $84556724c483b9e3$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $84556724c483b9e3$var$createReactiveObject(target, false, $84556724c483b9e3$var$mutableHandlers, $84556724c483b9e3$var$mutableCollectionHandlers, $84556724c483b9e3$var$reactiveMap);
}
function $84556724c483b9e3$var$readonly(target) {
    return $84556724c483b9e3$var$createReactiveObject(target, true, $84556724c483b9e3$var$readonlyHandlers, $84556724c483b9e3$var$readonlyCollectionHandlers, $84556724c483b9e3$var$readonlyMap);
}
function $84556724c483b9e3$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$84556724c483b9e3$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $84556724c483b9e3$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $84556724c483b9e3$var$toRaw(observed) {
    return observed && $84556724c483b9e3$var$toRaw(observed["__v_raw"]) || observed;
}
function $84556724c483b9e3$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$84556724c483b9e3$var$magic("nextTick", ()=>$84556724c483b9e3$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$84556724c483b9e3$var$magic("dispatch", (el)=>$84556724c483b9e3$var$dispatch.bind($84556724c483b9e3$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$84556724c483b9e3$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $84556724c483b9e3$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$84556724c483b9e3$var$magic("store", $84556724c483b9e3$var$getStores);
// packages/alpinejs/src/magics/$data.js
$84556724c483b9e3$var$magic("data", (el)=>$84556724c483b9e3$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$84556724c483b9e3$var$magic("root", (el)=>$84556724c483b9e3$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$84556724c483b9e3$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $84556724c483b9e3$var$mergeProxies($84556724c483b9e3$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $84556724c483b9e3$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $84556724c483b9e3$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $84556724c483b9e3$var$globalIdMemo = {};
function $84556724c483b9e3$var$findAndIncrementId(name) {
    if (!$84556724c483b9e3$var$globalIdMemo[name]) $84556724c483b9e3$var$globalIdMemo[name] = 0;
    return ++$84556724c483b9e3$var$globalIdMemo[name];
}
function $84556724c483b9e3$var$closestIdRoot(el, name) {
    return $84556724c483b9e3$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $84556724c483b9e3$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $84556724c483b9e3$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$84556724c483b9e3$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $84556724c483b9e3$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $84556724c483b9e3$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $84556724c483b9e3$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$84556724c483b9e3$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $84556724c483b9e3$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$84556724c483b9e3$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$84556724c483b9e3$var$warnMissingPluginMagic("Focus", "focus", "focus");
$84556724c483b9e3$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $84556724c483b9e3$var$warnMissingPluginMagic(name, magicName, slug) {
    $84556724c483b9e3$var$magic(magicName, (el)=>$84556724c483b9e3$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$84556724c483b9e3$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $84556724c483b9e3$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$84556724c483b9e3$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $84556724c483b9e3$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $84556724c483b9e3$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $84556724c483b9e3$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $84556724c483b9e3$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $84556724c483b9e3$var$skipDuringClone(()=>{
            $84556724c483b9e3$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $84556724c483b9e3$var$getTarget(expression);
        $84556724c483b9e3$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$84556724c483b9e3$var$mutateDom(()=>{
            clone2.remove();
            $84556724c483b9e3$var$destroyTree(clone2);
        }));
});
var $84556724c483b9e3$var$teleportContainerDuringClone = document.createElement("div");
function $84556724c483b9e3$var$getTarget(expression) {
    let target = $84556724c483b9e3$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $84556724c483b9e3$var$teleportContainerDuringClone;
    })();
    if (!target) $84556724c483b9e3$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $84556724c483b9e3$var$handler = ()=>{};
$84556724c483b9e3$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$84556724c483b9e3$var$directive("ignore", $84556724c483b9e3$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$84556724c483b9e3$var$directive("effect", $84556724c483b9e3$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($84556724c483b9e3$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $84556724c483b9e3$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $84556724c483b9e3$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $84556724c483b9e3$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $84556724c483b9e3$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $84556724c483b9e3$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $84556724c483b9e3$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $84556724c483b9e3$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($84556724c483b9e3$var$isKeyEvent(event) || $84556724c483b9e3$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($84556724c483b9e3$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $84556724c483b9e3$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $84556724c483b9e3$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $84556724c483b9e3$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $84556724c483b9e3$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $84556724c483b9e3$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $84556724c483b9e3$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $84556724c483b9e3$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $84556724c483b9e3$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $84556724c483b9e3$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $84556724c483b9e3$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($84556724c483b9e3$var$isClickEvent(e.type)) return false;
            if ($84556724c483b9e3$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $84556724c483b9e3$var$keyToModifiers(key) {
    if (!key) return [];
    key = $84556724c483b9e3$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$84556724c483b9e3$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $84556724c483b9e3$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $84556724c483b9e3$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $84556724c483b9e3$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $84556724c483b9e3$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($84556724c483b9e3$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $84556724c483b9e3$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $84556724c483b9e3$var$isCloning ? ()=>{} : $84556724c483b9e3$var$on(el, event, modifiers, (e)=>{
        setValue($84556724c483b9e3$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $84556724c483b9e3$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($84556724c483b9e3$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $84556724c483b9e3$var$on(el.form, "reset", [], (e)=>{
            $84556724c483b9e3$var$nextTick(()=>el._x_model && el._x_model.set($84556724c483b9e3$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $84556724c483b9e3$var$mutateDom(()=>$84556724c483b9e3$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $84556724c483b9e3$var$getInputValue(el, modifiers, event, currentValue) {
    return $84556724c483b9e3$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($84556724c483b9e3$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $84556724c483b9e3$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $84556724c483b9e3$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$84556724c483b9e3$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $84556724c483b9e3$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $84556724c483b9e3$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($84556724c483b9e3$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $84556724c483b9e3$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $84556724c483b9e3$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $84556724c483b9e3$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $84556724c483b9e3$var$isNumeric2(number) ? number : rawValue;
}
function $84556724c483b9e3$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $84556724c483b9e3$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $84556724c483b9e3$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$84556724c483b9e3$var$directive("cloak", (el)=>queueMicrotask(()=>$84556724c483b9e3$var$mutateDom(()=>el.removeAttribute($84556724c483b9e3$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$84556724c483b9e3$var$addInitSelector(()=>`[${$84556724c483b9e3$var$prefix("init")}]`);
$84556724c483b9e3$var$directive("init", $84556724c483b9e3$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$84556724c483b9e3$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $84556724c483b9e3$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$84556724c483b9e3$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $84556724c483b9e3$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $84556724c483b9e3$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$84556724c483b9e3$var$mapAttributes($84556724c483b9e3$var$startingWith(":", $84556724c483b9e3$var$into($84556724c483b9e3$var$prefix("bind:"))));
var $84556724c483b9e3$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $84556724c483b9e3$var$injectBindingProviders(bindingProviders);
        let getBindings = $84556724c483b9e3$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $84556724c483b9e3$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $84556724c483b9e3$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $84556724c483b9e3$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $84556724c483b9e3$var$mutateDom(()=>$84556724c483b9e3$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$84556724c483b9e3$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$84556724c483b9e3$var$directive("bind", $84556724c483b9e3$var$handler2);
function $84556724c483b9e3$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$84556724c483b9e3$var$addRootSelector(()=>`[${$84556724c483b9e3$var$prefix("data")}]`);
$84556724c483b9e3$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($84556724c483b9e3$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $84556724c483b9e3$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $84556724c483b9e3$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $84556724c483b9e3$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $84556724c483b9e3$var$injectMagics(data2, el);
    let reactiveData = $84556724c483b9e3$var$reactive(data2);
    $84556724c483b9e3$var$initInterceptors(reactiveData);
    let undo = $84556724c483b9e3$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $84556724c483b9e3$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $84556724c483b9e3$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$84556724c483b9e3$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $84556724c483b9e3$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$84556724c483b9e3$var$isCloning) return false;
    if ($84556724c483b9e3$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$84556724c483b9e3$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $84556724c483b9e3$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $84556724c483b9e3$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $84556724c483b9e3$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $84556724c483b9e3$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$84556724c483b9e3$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $84556724c483b9e3$var$parseForExpression(expression);
    let evaluateItems = $84556724c483b9e3$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $84556724c483b9e3$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$84556724c483b9e3$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$84556724c483b9e3$var$mutateDom(()=>{
                $84556724c483b9e3$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $84556724c483b9e3$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($84556724c483b9e3$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $84556724c483b9e3$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $84556724c483b9e3$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $84556724c483b9e3$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $84556724c483b9e3$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $84556724c483b9e3$var$mutateDom(()=>{
                $84556724c483b9e3$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $84556724c483b9e3$var$mutateDom(()=>{
                if (!elForSpot) $84556724c483b9e3$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $84556724c483b9e3$var$reactive(scope2);
            $84556724c483b9e3$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $84556724c483b9e3$var$mutateDom(()=>{
                lastEl.after(clone2);
                $84556724c483b9e3$var$skipDuringClone(()=>$84556724c483b9e3$var$initTree(clone2))();
            });
            if (typeof key === "object") $84556724c483b9e3$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $84556724c483b9e3$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $84556724c483b9e3$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $84556724c483b9e3$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $84556724c483b9e3$var$handler3() {}
$84556724c483b9e3$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $84556724c483b9e3$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$84556724c483b9e3$var$directive("ref", $84556724c483b9e3$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$84556724c483b9e3$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $84556724c483b9e3$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $84556724c483b9e3$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $84556724c483b9e3$var$addScopeToNode(clone2, {}, el);
        $84556724c483b9e3$var$mutateDom(()=>{
            el.after(clone2);
            $84556724c483b9e3$var$skipDuringClone(()=>$84556724c483b9e3$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $84556724c483b9e3$var$mutateDom(()=>{
                $84556724c483b9e3$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$84556724c483b9e3$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$84556724c483b9e3$var$setIdRoot(el, name));
});
$84556724c483b9e3$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$84556724c483b9e3$var$mapAttributes($84556724c483b9e3$var$startingWith("@", $84556724c483b9e3$var$into($84556724c483b9e3$var$prefix("on:"))));
$84556724c483b9e3$var$directive("on", $84556724c483b9e3$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $84556724c483b9e3$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $84556724c483b9e3$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$84556724c483b9e3$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$84556724c483b9e3$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$84556724c483b9e3$var$warnMissingPluginDirective("Focus", "trap", "focus");
$84556724c483b9e3$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $84556724c483b9e3$var$warnMissingPluginDirective(name, directiveName, slug) {
    $84556724c483b9e3$var$directive(directiveName, (el)=>$84556724c483b9e3$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$84556724c483b9e3$var$alpine_default.setEvaluator($84556724c483b9e3$var$normalEvaluator);
$84556724c483b9e3$var$alpine_default.setReactivityEngine({
    reactive: $84556724c483b9e3$var$reactive2,
    effect: $84556724c483b9e3$var$effect2,
    release: $84556724c483b9e3$var$stop,
    raw: $84556724c483b9e3$var$toRaw
});
var $84556724c483b9e3$export$b7ee041e4ad2afec = $84556724c483b9e3$var$alpine_default;
// packages/alpinejs/builds/module.js
var $84556724c483b9e3$export$2e2bcd8739ae039 = $84556724c483b9e3$export$b7ee041e4ad2afec;


const $259ce7fa7b92febc$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $259ce7fa7b92febc$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $259ce7fa7b92febc$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($259ce7fa7b92febc$var$e(t) ? t : $259ce7fa7b92febc$var$i(t.parentElement, n));
}, $259ce7fa7b92febc$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $259ce7fa7b92febc$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $259ce7fa7b92febc$var$o = (t, e, i)=>{
    t && $259ce7fa7b92febc$var$s(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $259ce7fa7b92febc$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $259ce7fa7b92febc$var$r = {
    passive: !1
};
class $259ce7fa7b92febc$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $259ce7fa7b92febc$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $259ce7fa7b92febc$var$r), this.element.addEventListener("touchmove", this.onMove, $259ce7fa7b92febc$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $259ce7fa7b92febc$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $259ce7fa7b92febc$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $259ce7fa7b92febc$var$a(t)) : [
            new $259ce7fa7b92febc$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $259ce7fa7b92febc$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $259ce7fa7b92febc$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $259ce7fa7b92febc$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $259ce7fa7b92febc$var$r), this.element.removeEventListener("touchmove", this.onMove, $259ce7fa7b92febc$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $259ce7fa7b92febc$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $259ce7fa7b92febc$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $259ce7fa7b92febc$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $259ce7fa7b92febc$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $259ce7fa7b92febc$var$d(i) ? Object.assign(t[e], $259ce7fa7b92febc$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $259ce7fa7b92febc$var$p = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $259ce7fa7b92febc$var$f {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $259ce7fa7b92febc$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $259ce7fa7b92febc$var$p(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $259ce7fa7b92febc$var$p(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $259ce7fa7b92febc$var$p(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($259ce7fa7b92febc$var$f, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($259ce7fa7b92febc$var$f, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $259ce7fa7b92febc$var$g extends $259ce7fa7b92febc$var$f {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $259ce7fa7b92febc$var$m;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($259ce7fa7b92febc$var$m || ($259ce7fa7b92febc$var$m = {}));
const $259ce7fa7b92febc$var$v = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $259ce7fa7b92febc$var$b = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $259ce7fa7b92febc$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $259ce7fa7b92febc$var$b
}, $259ce7fa7b92febc$var$w = '<circle cx="25" cy="25" r="20"></circle>', $259ce7fa7b92febc$var$x = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + $259ce7fa7b92febc$var$w + $259ce7fa7b92febc$var$w + "</svg></div>", $259ce7fa7b92febc$var$E = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $259ce7fa7b92febc$var$S = (t, e)=>{
    t && $259ce7fa7b92febc$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $259ce7fa7b92febc$var$P = (t, e)=>{
    t && $259ce7fa7b92febc$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $259ce7fa7b92febc$var$C = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $259ce7fa7b92febc$var$T = 1e5, $259ce7fa7b92febc$var$M = 1e4, $259ce7fa7b92febc$var$O = "mousemove", $259ce7fa7b92febc$var$A = "drag", $259ce7fa7b92febc$var$L = "content", $259ce7fa7b92febc$var$z = "auto";
let $259ce7fa7b92febc$var$R = null, $259ce7fa7b92febc$var$k = null;
class $259ce7fa7b92febc$export$b704d075ddd20210 extends $259ce7fa7b92febc$var$g {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $259ce7fa7b92febc$var$k && ($259ce7fa7b92febc$var$k = window.matchMedia("(hover: none)").matches), $259ce7fa7b92febc$var$k;
    }
    get isMobile() {
        return null === $259ce7fa7b92febc$var$R && ($259ce7fa7b92febc$var$R = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $259ce7fa7b92febc$var$R;
    }
    get panMode() {
        return this.options.panMode !== $259ce7fa7b92febc$var$O || this.isTouchDevice ? $259ce7fa7b92febc$var$A : $259ce7fa7b92febc$var$O;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return t === $259ce7fa7b92febc$var$z ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $259ce7fa7b92febc$var$v){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $259ce7fa7b92febc$var$m.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $259ce7fa7b92febc$var$C)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $259ce7fa7b92febc$var$C)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $259ce7fa7b92febc$export$b704d075ddd20210.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $259ce7fa7b92febc$var$n($259ce7fa7b92febc$var$x);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($259ce7fa7b92febc$var$L);
        let i = this.option($259ce7fa7b92febc$var$L) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $259ce7fa7b92febc$var$P(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $259ce7fa7b92febc$var$m.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $259ce7fa7b92febc$var$m.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $259ce7fa7b92febc$var$m.Error, this.emit("error"));
    }
    getNextScale(t) {
        const { fullScale: e, targetScale: i, coverScale: n, maxScale: s, minScale: o } = this;
        let a = o;
        switch(t){
            case "toggleMax":
                a = i - o < .5 * (s - o) ? s : o;
                break;
            case "toggleCover":
                a = i - o < .5 * (n - o) ? n : o;
                break;
            case "toggleZoom":
                a = i - o < .5 * (e - o) ? e : o;
                break;
            case "iterateZoom":
                let t1 = [
                    1,
                    e,
                    s
                ].sort((t, e)=>t - e), r = t1.findIndex((t)=>t > i + 1e-5);
                a = t1[r] || 1;
        }
        return a;
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $259ce7fa7b92febc$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($259ce7fa7b92febc$var$O, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($259ce7fa7b92febc$var$O, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $259ce7fa7b92febc$var$v)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $259ce7fa7b92febc$var$v)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, p = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(p) < 1e-4 && (p = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: p,
            inBounds: !u && !p
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0 + h).matrixTransform(d), g = new DOMPoint(0, 0 + h).matrixTransform(d), m = Math.abs(f.x - u.x), v = Math.abs(f.y - u.y), b = Math.abs(g.x - p.x), y = Math.abs(g.y - p.y);
            r = Math.max(m, b), l = Math.max(v, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $259ce7fa7b92febc$var$O || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $259ce7fa7b92febc$var$v)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $259ce7fa7b92febc$var$m.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $259ce7fa7b92febc$var$E(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const c = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, h = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && h && c(h)) : (this.emit("dblClick", t), t.defaultPrevented || c(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && h && c(h));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $259ce7fa7b92febc$var$O && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $259ce7fa7b92febc$var$t(this.targetScale) <= $259ce7fa7b92febc$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $259ce7fa7b92febc$var$h(s[0], s[1]), r = $259ce7fa7b92febc$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $259ce7fa7b92febc$var$c(s[0], s[1]), p = $259ce7fa7b92febc$var$c(n[0], n[1]);
        let f = u ? p / u : 1, g = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += g, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let v = $259ce7fa7b92febc$var$t(this.targetScale) === $259ce7fa7b92febc$var$t(this.minScale) && this.option("lockAxis");
        if (v && !this.lockedAxis) {
            if ("xy" === v || "y" === v || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, g = 0, m = 0;
            } else this.lockedAxis = v;
        }
        if ($259ce7fa7b92febc$var$i(e.target, this.content) && (v = "x", this.dragOffset.y = 0), v && "xy" !== v && this.lockedAxis !== v && $259ce7fa7b92febc$var$t(this.targetScale) === $259ce7fa7b92febc$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const b = this.checkBounds(g, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (b.xDiff > 0 && g < 0 || b.xDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * b.xDiff))), "y" !== this.isInfinite && (b.yDiff > 0 && m < 0 || b.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * b.yDiff)))) : (b.xDiff && (g = 0), b.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && $259ce7fa7b92febc$var$t(y) === $259ce7fa7b92febc$var$t(w) && (g = 0), "x" === this.lockedAxis && $259ce7fa7b92febc$var$t(y) === $259ce7fa7b92febc$var$t(w) && (m = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: g,
            panY: m,
            scale: f,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $259ce7fa7b92febc$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $259ce7fa7b92febc$var$m.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $259ce7fa7b92febc$var$v)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $259ce7fa7b92febc$var$S(this.container, "is-scaling"), $259ce7fa7b92febc$var$S(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, p = 0, f = this.option("decelFriction");
        const g = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, p = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), p = Math.max(Math.min(p, t), -1 * t));
        }
        u && (h = u / (1 / (1 - f) - 1)), p && (d = p / (1 / (1 - f) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $259ce7fa7b92febc$var$t(g) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $259ce7fa7b92febc$var$t(g) === this.minScale) && (d = p = 0);
        const m = this.dragOffset.x, b = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(m) < y && Math.abs(b) < y && (h = d = 0, u = p = 0), (this.option("zoom") && (g < this.minScale - 1e-5 || g > this.maxScale + 1e-5) || i && !h && !d) && (f = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: f
        }), this.emit("decel", u, p, m, b);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $259ce7fa7b92febc$var$O) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $259ce7fa7b92febc$var$C);
        for (const n of $259ce7fa7b92febc$var$v){
            const s = "e" == n || "f" === n ? $259ce7fa7b92febc$var$M : $259ce7fa7b92febc$var$T;
            o[n] = $259ce7fa7b92febc$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
        p.style.transform = u;
        const { contentWidth: f, contentHeight: g } = this.calculateContentDim();
        s.width = f, s.height = g, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $259ce7fa7b92febc$var$m.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), p = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: p
        };
        const f = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o), g = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o);
        let v = this.option("width", f) || $259ce7fa7b92febc$var$z, b = this.option("height", g) || $259ce7fa7b92febc$var$z;
        const y = v === $259ce7fa7b92febc$var$z, w = b === $259ce7fa7b92febc$var$z;
        "number" != typeof v && (v = f), "number" != typeof b && (b = g), y && (v = f * (b / g)), w && (b = g / (f / v));
        let x = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (x = x.parentElement || x);
        const E = x.getAttribute("style") || "";
        x.style.setProperty("transform", "none", "important"), a && (x.style.width = "", x.style.height = ""), x.offsetHeight;
        const S = o.getBoundingClientRect();
        let P = S.width * n, C = S.height * n, T = P, M = C;
        P = Math.min(P, v), C = Math.min(C, b), a ? { width: P, height: C } = ((t, e, i, n)=>{
            const s = i / t, o = n / e, a = Math.min(s, o);
            return {
                width: t *= a,
                height: e *= a
            };
        })(v, b, P, C) : (P = Math.min(P, v), C = Math.min(C, b));
        let O = .5 * (M - C), A = .5 * (T - P);
        this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: S.top - r.top + O,
            bottom: r.bottom - S.bottom + O,
            left: S.left - r.left + A,
            right: r.right - S.right + A,
            fitWidth: P,
            fitHeight: C,
            width: P,
            height: C,
            fullWidth: v,
            fullHeight: b
        }), x.style.cssText = E, a && (x.style.width = `${P}px`, x.style.height = `${C}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($259ce7fa7b92febc$var$t(this.targetScale) < $259ce7fa7b92febc$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $259ce7fa7b92febc$var$m.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, c = 0, h = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, c = 1 / 0, l = -1 / 0, h = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $259ce7fa7b92febc$var$t(o * n, $259ce7fa7b92febc$var$M), p = $259ce7fa7b92febc$var$t(a * n, $259ce7fa7b92febc$var$M), { innerWidth: f, innerHeight: g } = s;
            if (s.width === u && (f = s.width), s.width === p && (g = s.height), e > f) {
                c = .5 * (e - f), r = -1 * c;
                let t = .5 * (d.right - d.left);
                r += t, c += t;
            }
            if (o > f && e < f && (r -= .5 * (o - f), c -= .5 * (o - f)), i > g) {
                h = .5 * (i - g), l = -1 * h;
                let t = .5 * (d.bottom - d.top);
                l += t, h += t;
            }
            a > g && i < g && (r -= .5 * (a - g), c -= .5 * (a - g));
        }
        return {
            x: {
                min: r,
                max: c
            },
            y: {
                min: l,
                max: h
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return t !== $259ce7fa7b92febc$var$z ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, targetScale: a, minScale: r } = e;
        let l = r, c = e.option("click") || !1;
        c && (l = e.getNextScale(c));
        let h = e.canZoomIn(), d = e.canZoomOut(), u = n === $259ce7fa7b92febc$var$A && !!this.option("touch"), p = d && u;
        if (u && ($259ce7fa7b92febc$var$t(a) < $259ce7fa7b92febc$var$t(r) && !this.panOnlyZoomed && (p = !0), ($259ce7fa7b92febc$var$t(s.width, 1) > $259ce7fa7b92febc$var$t(s.fitWidth, 1) || $259ce7fa7b92febc$var$t(s.height, 1) > $259ce7fa7b92febc$var$t(s.fitHeight, 1)) && (p = !0)), $259ce7fa7b92febc$var$t(s.width * a, 1) < $259ce7fa7b92febc$var$t(s.fitWidth, 1) && (p = !1), n === $259ce7fa7b92febc$var$O && (p = !1), $259ce7fa7b92febc$var$o(i, this.cn("isDraggable"), p), !this.option("zoom")) return;
        let f = h && $259ce7fa7b92febc$var$t(l) > $259ce7fa7b92febc$var$t(a), g = !f && !p && d && $259ce7fa7b92febc$var$t(l) < $259ce7fa7b92febc$var$t(a);
        $259ce7fa7b92febc$var$o(i, this.cn("canZoomIn"), f), $259ce7fa7b92febc$var$o(i, this.cn("canZoomOut"), g);
        for (const t of i.querySelectorAll("[data-panzoom-action]")){
            let e = !1, i = !1;
            switch(t.dataset.panzoomAction){
                case "zoomIn":
                    h ? e = !0 : i = !0;
                    break;
                case "zoomOut":
                    d ? e = !0 : i = !0;
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    h || d ? e = !0 : i = !0;
                    const n = t.querySelector("g");
                    n && (n.style.display = h ? "" : "none");
            }
            e ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : i && (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $259ce7fa7b92febc$var$m.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $259ce7fa7b92febc$var$m.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: p } = this, f = p.e, g = p.f, b = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(f, g).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-f, -g).multiply(b), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), c && (y = y.scale(1, -1));
        for (const e of $259ce7fa7b92febc$var$v)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $259ce7fa7b92febc$var$t(y[e], $259ce7fa7b92febc$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $259ce7fa7b92febc$var$O || !1 === d) && !h && this.clampTargetBounds(), u === $259ce7fa7b92febc$var$m.Init ? this.animate() : this.isResting || (this.state = $259ce7fa7b92febc$var$m.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $259ce7fa7b92febc$var$m.Init || this.state === $259ce7fa7b92febc$var$m.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $259ce7fa7b92febc$var$v)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $259ce7fa7b92febc$var$S(this.container, "is-scaling"), $259ce7fa7b92febc$var$S(this.container, "is-animating"), this.isTicking = !1, this.state = $259ce7fa7b92febc$var$m.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $259ce7fa7b92febc$var$P(this.container, "is-animating"), this.isScaling && $259ce7fa7b92febc$var$P(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $259ce7fa7b92febc$var$O || !e) return;
        if ($259ce7fa7b92febc$var$t(this.targetScale) <= $259ce7fa7b92febc$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const p = this.option("mouseMoveFactor");
        p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
        let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        f += .5 * (o.right - o.left);
        let g = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        g += .5 * (o.bottom - o.top), this.applyChange({
            panX: f - this.target.e,
            panY: g - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $259ce7fa7b92febc$var$m.Destroy || this.state === $259ce7fa7b92febc$var$m.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $259ce7fa7b92febc$var$t(l) < $259ce7fa7b92febc$var$t(r) && $259ce7fa7b92febc$var$t(o) <= $259ce7fa7b92febc$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $259ce7fa7b92febc$var$t(l) > $259ce7fa7b92febc$var$t(a) && $259ce7fa7b92febc$var$t(o) >= $259ce7fa7b92febc$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $259ce7fa7b92febc$var$t(l) !== $259ce7fa7b92febc$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($259ce7fa7b92febc$var$t(this.contentRect.width, 1) < $259ce7fa7b92febc$var$t(this.contentRect.fitWidth, 1) || $259ce7fa7b92febc$var$t(this.targetScale) < $259ce7fa7b92febc$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $259ce7fa7b92febc$var$t(this.targetScale) > $259ce7fa7b92febc$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.getNextScale("toggleZoom"), t);
    }
    toggleMax(t) {
        this.zoomTo(this.getNextScale("toggleMax"), t);
    }
    toggleCover(t) {
        this.zoomTo(this.getNextScale("toggleCover"), t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = $259ce7fa7b92febc$var$z, originX: i = $259ce7fa7b92febc$var$z, originY: n = $259ce7fa7b92febc$var$z, event: s } = {}) {
        if (this.isContentLoading || this.state === $259ce7fa7b92febc$var$m.Destroy) return;
        const { targetScale: o, fullScale: a, maxScale: r, coverScale: l } = this;
        if (this.stop(), this.panMode === $259ce7fa7b92febc$var$O && (s = this.pmme || s), s || i === $259ce7fa7b92febc$var$z || n === $259ce7fa7b92febc$var$z) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        let c = 1;
        "number" == typeof t ? c = t : "full" === t ? c = a : "cover" === t ? c = l : "max" === t ? c = r : "fit" === t ? c = 1 : "next" === t && (c = this.getNextScale("iterateZoom")), c = c / o || 1, e = e === $259ce7fa7b92febc$var$z ? c > 1 ? .15 : .25 : e, this.applyChange({
            scale: c,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $259ce7fa7b92febc$var$O && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $259ce7fa7b92febc$var$m.Init && this.state !== $259ce7fa7b92febc$var$m.Destroy) {
            this.stop("current");
            for (const t of $259ce7fa7b92febc$var$v)this.target[t] = $259ce7fa7b92febc$var$C[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $259ce7fa7b92febc$var$m.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $259ce7fa7b92febc$var$m.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($259ce7fa7b92febc$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$y
}), Object.defineProperty($259ce7fa7b92febc$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $259ce7fa7b92febc$var$D = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $259ce7fa7b92febc$var$F = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $259ce7fa7b92febc$var$j = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $259ce7fa7b92febc$var$B;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($259ce7fa7b92febc$var$B || ($259ce7fa7b92febc$var$B = {}));
const $259ce7fa7b92febc$var$H = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $259ce7fa7b92febc$var$N = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $259ce7fa7b92febc$var$_ extends $259ce7fa7b92febc$var$f {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $259ce7fa7b92febc$var$$ = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $259ce7fa7b92febc$var$W extends $259ce7fa7b92febc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $259ce7fa7b92febc$var$P(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $259ce7fa7b92febc$var$P(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($259ce7fa7b92febc$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $259ce7fa7b92febc$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$259ce7fa7b92febc$var$S(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $259ce7fa7b92febc$var$P(t, this.cn("isPrev")), $259ce7fa7b92febc$var$P(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $259ce7fa7b92febc$var$P(i, this.cn("isNext")), $259ce7fa7b92febc$var$P(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $259ce7fa7b92febc$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $259ce7fa7b92febc$var$S(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($259ce7fa7b92febc$var$W, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$$
});
const $259ce7fa7b92febc$var$X = "disabled", $259ce7fa7b92febc$var$q = "next", $259ce7fa7b92febc$var$Y = "prev";
class $259ce7fa7b92febc$var$V extends $259ce7fa7b92febc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($259ce7fa7b92febc$var$X), s.removeAttribute($259ce7fa7b92febc$var$X), t.isInfinite || (i <= 0 && n.setAttribute($259ce7fa7b92febc$var$X, ""), i >= e - 1 && s.setAttribute($259ce7fa7b92febc$var$X, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $259ce7fa7b92febc$var$P(n, this.cn("button") + " " + this.cn(t === $259ce7fa7b92febc$var$q ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $259ce7fa7b92febc$var$q ? $259ce7fa7b92febc$var$Y : $259ce7fa7b92febc$var$q : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $259ce7fa7b92febc$var$P(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($259ce7fa7b92febc$var$q)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($259ce7fa7b92febc$var$Y)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($259ce7fa7b92febc$var$V, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $259ce7fa7b92febc$var$Z extends $259ce7fa7b92febc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $259ce7fa7b92febc$var$B.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $259ce7fa7b92febc$var$B.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $259ce7fa7b92febc$var$B.Ready || i.state !== $259ce7fa7b92febc$var$B.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $259ce7fa7b92febc$var$B.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($259ce7fa7b92febc$var$Z, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $259ce7fa7b92febc$var$U = {
    Navigation: $259ce7fa7b92febc$var$V,
    Dots: $259ce7fa7b92febc$var$W,
    Sync: $259ce7fa7b92febc$var$Z
}, $259ce7fa7b92febc$var$G = "animationend", $259ce7fa7b92febc$var$K = "isSelected", $259ce7fa7b92febc$var$J = "slide";
class $259ce7fa7b92febc$export$144901db2ea8e967 extends $259ce7fa7b92febc$var$g {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $259ce7fa7b92febc$var$B.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $259ce7fa7b92febc$var$B.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$259ce7fa7b92febc$var$E(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $259ce7fa7b92febc$var$D(this.slideNext.bind(this), 150), this.slidePrev = $259ce7fa7b92febc$var$D(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $259ce7fa7b92febc$var$u({}, $259ce7fa7b92febc$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $259ce7fa7b92febc$var$d(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $259ce7fa7b92febc$var$d(e) && (n += t, $259ce7fa7b92febc$var$u(i, e));
        n === this.bp && this.state !== $259ce7fa7b92febc$var$B.Init || (this.bp = n, this.state === $259ce7fa7b92febc$var$B.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $259ce7fa7b92febc$var$B.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $259ce7fa7b92febc$var$B.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $259ce7fa7b92febc$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $259ce7fa7b92febc$var$B.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $259ce7fa7b92febc$var$P(t, this.cn("container")), $259ce7fa7b92febc$var$o(t, e.isLTR, !this.isRTL), $259ce7fa7b92febc$var$o(t, e.isRTL, this.isRTL), $259ce7fa7b92febc$var$o(t, e.isVertical, !this.isHorizontal), $259ce7fa7b92febc$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $259ce7fa7b92febc$var$P(i, e.viewport), i.append(...$259ce7fa7b92febc$var$F(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $259ce7fa7b92febc$var$P(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$259ce7fa7b92febc$var$F(t, `.${this.cn($259ce7fa7b92febc$var$J)}`)
        ].forEach((t)=>{
            if ($259ce7fa7b92febc$var$E(t)) {
                const e = $259ce7fa7b92febc$var$H({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ])i.push($259ce7fa7b92febc$var$H(t));
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $259ce7fa7b92febc$export$b704d075ddd20210(this.viewport, $259ce7fa7b92febc$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($259ce7fa7b92febc$var$N()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $259ce7fa7b92febc$var$t(e.pos, 1e3), e.dim = $259ce7fa7b92febc$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let c;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            c && e.pos === c.pos ? (c.dim += e.dim, c.slides = [
                ...c.slides,
                ...e.slides
            ]) : (e.index = l.length, c = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = !(!r || r.parentNode);
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $259ce7fa7b92febc$var$P(r, this.cn($259ce7fa7b92febc$var$J) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r), o = r.getBoundingClientRect()[s] * Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            let t = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            t - 1 > o && (o = t);
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $259ce7fa7b92febc$var$t(o, 1e3),
            gap: $259ce7fa7b92febc$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, p = 0, f = 0, g = 0;
        d ? g = -1 * d.current[this.axis] : c[l] && (g = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (g *= -1);
        for (const i of h){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === p ? "" : `${$259ce7fa7b92febc$var$t(p, 1e3)}px` : n.style[e] = "", f += i.dim + i.gap, u++) : p += i.dim + i.gap;
        }
        if (s && f && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            g -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($259ce7fa7b92febc$var$t(i.pos) < $259ce7fa7b92febc$var$t(a) && $259ce7fa7b92febc$var$t(i.pos + i.dim + i.gap) < $259ce7fa7b92febc$var$t(g) && $259ce7fa7b92febc$var$t(g) > $259ce7fa7b92febc$var$t(r - a) && (i.el.style[e] = `${$259ce7fa7b92febc$var$t(p + f, 1e3)}px`), $259ce7fa7b92febc$var$t(i.pos + i.gap) >= $259ce7fa7b92febc$var$t(r - a) && $259ce7fa7b92febc$var$t(i.pos) > $259ce7fa7b92febc$var$t(g + a) && $259ce7fa7b92febc$var$t(g) < $259ce7fa7b92febc$var$t(a) && (i.el.style[e] = `-${$259ce7fa7b92febc$var$t(f, 1e3)}px`));
        }
        let m, v, b = [
            ...this.inTransition
        ];
        if (b.length > 1 && (m = c[b[0]], v = c[b[1]]), m && v) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$259ce7fa7b92febc$var$t(i + (m.pos - v.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $259ce7fa7b92febc$var$P(n, this.cn($259ce7fa7b92febc$var$J)), $259ce7fa7b92febc$var$P(n, t.class), $259ce7fa7b92febc$var$P(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = null == t ? void 0 : t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($259ce7fa7b92febc$var$K);
        if (i.classList.contains(n) && ($259ce7fa7b92febc$var$S(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($259ce7fa7b92febc$var$G);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const c = this.getPageFromIndex(t);
        if (!l || !r[c] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        let h = t > a ? 1 : -1;
        this.isInfinite && (0 === a && t === r.length - 1 && (h = -1), a === r.length - 1 && 0 === t && (h = 1));
        const d = r[c].pos * (this.isRTL ? 1 : -1);
        if (a === c && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $259ce7fa7b92febc$var$P(this.container, this.cn("inTransition"));
        const p = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, f = (null === (o = r[c]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(f.index), this.createSlideEl(f);
        let g = p.el, m = f.el;
        u || e === $259ce7fa7b92febc$var$J || (e = "fadeFast", g = null);
        const v = this.isRTL ? "next" : "prev", b = this.isRTL ? "prev" : "next";
        return g && (this.inTransition.add(p.index), p.transition = e, g.addEventListener($259ce7fa7b92febc$var$G, this.onAnimationEnd), g.classList.add(`f-${e}Out`, `to-${h > 0 ? b : v}`)), m && (f.transition = e, m.addEventListener($259ce7fa7b92febc$var$G, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${h > 0 ? v : b}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(c), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($259ce7fa7b92febc$var$K);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($259ce7fa7b92febc$var$P(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($259ce7fa7b92febc$var$S(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const { axis: t, isHorizontal: e, isInfinite: i, isRTL: n, viewportDim: s, contentDim: o } = this, a = this.panzoom;
        if (!a || !i) return;
        let r = a.current[t], l = a.target[t] - r, c = 0, h = .5 * s;
        n && e ? (r < -h && (c = -1, r += o), r > o - h && (c = 1, r -= o)) : (r > h && (c = 1, r -= o), r < -o + h && (c = -1, r += o)), c && (a.current[t] = r, a.target[t] = r + l);
    }
    lazyLoadImg(t, e) {
        const i = this, s = "f-fadeIn", o = "is-preloading";
        let a = !1, r = null;
        const l = ()=>{
            a || (a = !0, r && (r.remove(), r = null), $259ce7fa7b92febc$var$S(e, o), e.complete && ($259ce7fa7b92febc$var$P(e, s), setTimeout(()=>{
                $259ce7fa7b92febc$var$S(e, s);
            }, 350)), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (i.updateMetrics(), i.setViewportHeight()), this.emit("load", t));
        };
        $259ce7fa7b92febc$var$P(e, o), e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.addEventListener("error", ()=>{
            l();
        }), e.addEventListener("load", ()=>{
            l();
        }), setTimeout(()=>{
            const i = e.parentNode;
            i && t.el && (e.complete ? l() : a || (r = $259ce7fa7b92febc$var$n($259ce7fa7b92febc$var$x), i.insertBefore(r, e)));
        }, 300);
    }
    lazyLoadSlide(t) {
        const e = t && t.el;
        if (!e) return;
        const i = new Set;
        let n = Array.from(e.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        e.dataset.lazySrc && n.push(e), n.map((t)=>{
            t instanceof HTMLImageElement ? i.add(t) : t instanceof HTMLElement && t.dataset.lazySrc && (t.style.backgroundImage = `url('${t.dataset.lazySrc}')`, delete t.dataset.lazySrc);
        });
        for (const e of i)this.lazyLoadImg(t, e);
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        let u = this.page, p = o && a ? 1 : -1;
        const f = t.current[r] * p;
        let { pageIndex: g } = this.getPageFromPosition(f);
        Math.abs(d) > 5 ? (l[u].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (u = g), u = o && a ? d < 0 ? u - 1 : u + 1 : d < 0 ? u + 1 : u - 1) : u = 0 === n && 0 === s ? u : g, this.slideTo(u, {
            transition: !1,
            friction: t.option("decelFriction")
        });
    }
    onClick(t) {
        const e = t.target, i = e && $259ce7fa7b92febc$var$E(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $259ce7fa7b92febc$var$B.Init, this.prevPage = null, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $259ce7fa7b92febc$var$B.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, c = r.length, h = a && o ? 1 : -1;
        if (!l || !c) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * h;
            if (2 === c) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= h, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition();
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $259ce7fa7b92febc$var$S(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($259ce7fa7b92febc$var$G, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, c = this.contentDim < this.viewportDim;
        let h = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of h)d.push($259ce7fa7b92febc$var$H(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, h = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            c && 1 === n ? (t <= this.page && (a.current[this.axis] -= h, a.target[this.axis] -= h), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e;
        const i = this.slides[t];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(t, 1);
            for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
            this.updateMetrics(), this.slideTo(this.page, {
                friction: 0,
                transition: !1
            }), this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $259ce7fa7b92febc$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let c, h = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && c ? (n = c.dim, o = c.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), c = i), n = $259ce7fa7b92febc$var$t(n, 1e3), o = $259ce7fa7b92febc$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = h, h += n, (a || e < s.length - 1) && (h += o);
        }
        h = $259ce7fa7b92febc$var$t(h, 1e3), this.contentDim = h, e && (e.contentRect[r] = h, e.contentRect[o ? "fullWidth" : "fullHeight"] = h), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $259ce7fa7b92febc$var$B.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, c = $259ce7fa7b92febc$var$t((l - r.pos) / (1 * r.dim), 1e3), h = c, d = c;
        this.isInfinite && !0 !== n && (h = $259ce7fa7b92febc$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $259ce7fa7b92febc$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            c,
            h,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { panzoom: n, contentDim: s, viewportDim: o, pages: a, page: r } = this;
        if (o) {
            s = s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
            let l = 0;
            l = n && n.state !== $259ce7fa7b92febc$var$m.Init && n.state !== $259ce7fa7b92febc$var$m.Destroy ? -1 * n.current[this.axis] : a[r] && a[r].pos || 0, this.isInfinite && (l -= Math.floor(l / s) * s), this.isRTL && this.isHorizontal && (l *= -1);
            const c = l - o * t, h = l + o * (t + 1), d = this.isInfinite ? [
                -1,
                0,
                1
            ] : [
                0
            ];
            for (const t of this.slides)for (const e of d){
                const n = t.pos + e * s, o = n + t.dim + t.gap;
                n < h && o > c && i.add(t);
            }
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i, slides: n, pages: s, panzoom: o } = this, a = s.length, r = n.length, l = n[0], c = n[r - 1], h = this.option("center");
        let d = 0, u = 0, p = 0, f = void 0 === t ? -1 * ((null == o ? void 0 : o.target[this.axis]) || 0) : t;
        h && (f += .5 * e), this.isInfinite ? (f < l.pos - .5 * c.gap && (f -= i, p = -1), f > c.pos + c.dim + .5 * c.gap && (f -= i, p = 1)) : f = Math.max(l.pos || 0, Math.min(f, c.pos));
        let g = c, m = n.find((t)=>{
            const e = t.pos - .5 * g.gap, i = t.pos + t.dim + .5 * t.gap;
            return g = t, f >= e && f < i;
        });
        return m || (m = c), u = this.getPageForSlide(m.index), d = u + p * a, {
            page: d,
            pageIndex: u
        };
    }
    setPageFromPosition() {
        const { pageIndex: t } = this.getPageFromPosition();
        this.onChange(t);
    }
    destroy() {
        if ([
            $259ce7fa7b92febc$var$B.Destroy
        ].includes(this.state)) return;
        this.state = $259ce7fa7b92febc$var$B.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($259ce7fa7b92febc$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$export$b704d075ddd20210
}), Object.defineProperty($259ce7fa7b92febc$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$j
}), Object.defineProperty($259ce7fa7b92febc$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$U
});
const $259ce7fa7b92febc$var$tt = function(t) {
    if (!$259ce7fa7b92febc$var$E(t)) return 0;
    const e = window.scrollY, i = window.innerHeight, n = e + i, s = t.getBoundingClientRect(), o = s.y + e, a = s.height, r = o + a;
    if (e > r || n < o) return 0;
    if (e < o && n > r) return 100;
    if (o < e && r > n) return 100;
    let l = a;
    o < e && (l -= e - o), r > n && (l -= r - n);
    const c = l / i * 100;
    return Math.round(c);
}, $259ce7fa7b92febc$var$et = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $259ce7fa7b92febc$var$it;
const $259ce7fa7b92febc$var$nt = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $259ce7fa7b92febc$var$st = (t)=>{
    if (t && $259ce7fa7b92febc$var$et) {
        void 0 === $259ce7fa7b92febc$var$it && document.createElement("div").focus({
            get preventScroll () {
                return $259ce7fa7b92febc$var$it = !0, !1;
            }
        });
        try {
            if ($259ce7fa7b92febc$var$it) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.scrollY || document.body.scrollTop, i = window.scrollX || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $259ce7fa7b92febc$var$ot = ()=>{
    const t = document;
    let e, i = "", n = "", s = "";
    return t.fullscreenEnabled ? (i = "requestFullscreen", n = "exitFullscreen", s = "fullscreenElement") : t.webkitFullscreenEnabled && (i = "webkitRequestFullscreen", n = "webkitExitFullscreen", s = "webkitFullscreenElement"), i && (e = {
        request: function(e = t.documentElement) {
            return "webkitRequestFullscreen" === i ? e[i](Element.ALLOW_KEYBOARD_INPUT) : e[i]();
        },
        exit: function() {
            return t[s] && t[n]();
        },
        isFullscreen: function() {
            return t[s];
        }
    }), e;
}, $259ce7fa7b92febc$var$at = {
    animated: !0,
    autoFocus: !0,
    backdropClick: "close",
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    closeButton: "auto",
    closeExisting: !1,
    commonCaption: !1,
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    contentClick: "toggleZoom",
    contentDblClick: !1,
    defaultType: "image",
    defaultDisplay: "flex",
    dragToClose: !0,
    Fullscreen: {
        autoStart: !1
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    idle: 3500,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: Object.assign(Object.assign({}, $259ce7fa7b92febc$var$b), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    parentEl: null,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    trapFocus: !0,
    wheel: "zoom"
};
var $259ce7fa7b92febc$var$rt, $259ce7fa7b92febc$var$lt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($259ce7fa7b92febc$var$rt || ($259ce7fa7b92febc$var$rt = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($259ce7fa7b92febc$var$lt || ($259ce7fa7b92febc$var$lt = {}));
let $259ce7fa7b92febc$var$ct = "", $259ce7fa7b92febc$var$ht = !1, $259ce7fa7b92febc$var$dt = !1, $259ce7fa7b92febc$var$ut = null;
const $259ce7fa7b92febc$var$pt = ()=>{
    let t = "", e = "";
    const i = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance();
    if (i) {
        const n = i.carousel, s = i.getSlide();
        if (n && s) {
            let o = s.slug || void 0, a = s.triggerEl || void 0;
            e = o || i.option("slug") || "", !e && a && a.dataset && (e = a.dataset.fancybox || ""), e && "true" !== e && (t = "#" + e + (!o && n.slides.length > 1 ? "-" + (s.index + 1) : ""));
        }
    }
    return {
        hash: t,
        slug: e,
        index: 1
    };
}, $259ce7fa7b92febc$var$ft = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: n
    };
}, $259ce7fa7b92febc$var$gt = ()=>{
    const { slug: t, index: e } = $259ce7fa7b92febc$var$ft();
    if (!t) return;
    let i = document.querySelector(`[data-slug="${t}"]`);
    if (i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance()) return;
    const n = document.querySelectorAll(`[data-fancybox="${t}"]`);
    n.length && (i = n[e - 1], i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $259ce7fa7b92febc$var$mt = ()=>{
    if (!1 === $259ce7fa7b92febc$export$cb45b08d97cdc4fd.defaults.Hash) return;
    const t = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance();
    if (!1 === (null == t ? void 0 : t.options.Hash)) return;
    const { slug: e, index: i } = $259ce7fa7b92febc$var$ft(), { slug: n } = $259ce7fa7b92febc$var$pt();
    t && (e === n ? t.jumpTo(i - 1) : ($259ce7fa7b92febc$var$ht = !0, t.close())), $259ce7fa7b92febc$var$gt();
}, $259ce7fa7b92febc$var$vt = ()=>{
    $259ce7fa7b92febc$var$ut && clearTimeout($259ce7fa7b92febc$var$ut), queueMicrotask(()=>{
        $259ce7fa7b92febc$var$mt();
    });
}, $259ce7fa7b92febc$var$bt = ()=>{
    window.addEventListener("hashchange", $259ce7fa7b92febc$var$vt, !1), setTimeout(()=>{
        $259ce7fa7b92febc$var$mt();
    }, 500);
};
$259ce7fa7b92febc$var$et && (/complete|interactive|loaded/.test(document.readyState) ? $259ce7fa7b92febc$var$bt() : document.addEventListener("DOMContentLoaded", $259ce7fa7b92febc$var$bt));
const $259ce7fa7b92febc$var$yt = "is-zooming-in";
class $259ce7fa7b92febc$var$wt extends $259ce7fa7b92febc$var$_ {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        $259ce7fa7b92febc$var$S(this.instance.container, $259ce7fa7b92febc$var$yt);
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a, thumbElSrc: r } = n;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $259ce7fa7b92febc$var$m.Init || a.state === $259ce7fa7b92febc$var$m.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $259ce7fa7b92febc$var$rt.CustomClosing, i.classList.remove($259ce7fa7b92febc$var$yt), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${i.offsetTop + window.scrollY}px`,
            left: `${i.offsetLeft + window.scrollX}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: p } = l;
        if (p) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: p ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            const { contentEl: n, imageEl: s, thumbElSrc: o, el: a } = t;
            if (i.isClosing() || !n || !s) return;
            n.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected") && a) {
                a.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const t = document.createElement("div");
                $259ce7fa7b92febc$var$P(t, "fancybox-protected"), n.appendChild(t);
            }
            if (o && r) {
                const s = e.contentRect, a = Math.max(s.fullWidth, s.fullHeight);
                let c = null;
                !r.opacity && a > 1200 && (c = document.createElement("img"), $259ce7fa7b92febc$var$P(c, "fancybox-ghost"), c.src = o, n.appendChild(c));
                const h = ()=>{
                    c && ($259ce7fa7b92febc$var$P(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = o, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    i.hideLoading(t), t.state = $259ce7fa7b92febc$var$lt.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{}), c && setTimeout(()=>{
                        h();
                    }, a > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.hideLoading(t), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $259ce7fa7b92febc$var$n(l)), !l || !$259ce7fa7b92febc$var$E(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${(null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length) || 1}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset), this.instance.isOpeningSlide(t) && (l.fetchPriority = "high");
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            $259ce7fa7b92febc$var$P(l, "fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $259ce7fa7b92febc$export$b704d075ddd20210(r, $259ce7fa7b92febc$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: (e, i)=>a.optionFor(t, "width", "auto", i) || "auto",
                height: (e, i)=>a.optionFor(t, "height", "auto", i) || "auto",
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, p = ()=>{
                t.state !== $259ce7fa7b92febc$var$lt.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, f = (t)=>{
                (t.scale < .99 || t.scale > 1.01) && !t.isDragging || ($259ce7fa7b92febc$var$S(s, $259ce7fa7b92febc$var$yt), a.style.opacity = "", t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
            };
            o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const g = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, m = this.optionFor(t, "initialSize");
            $259ce7fa7b92febc$var$P(s, $259ce7fa7b92febc$var$yt), n.hideLoading(t), "full" === m ? o.zoomToFull(g) : "cover" === m ? o.zoomToCover(g) : "max" === m ? o.zoomToMax(g) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        const { el: e, imageEl: i, thumbEl: n, panzoom: s } = t, o = this.instance, a = o.container;
        if (!e || !i || !n || !s || $259ce7fa7b92febc$var$tt(n) < 3 || !this.optionFor(t, "zoom") || !a || o.state === $259ce7fa7b92febc$var$rt.Destroy) return !1;
        if ("0" === getComputedStyle(a).getPropertyValue("--f-images-zoom")) return !1;
        const r = window.visualViewport || null;
        if (1 !== (r ? r.scale : 1)) return !1;
        let { top: l, left: c, width: h, height: d } = n.getBoundingClientRect(), { top: u, left: p, fitWidth: f, fitHeight: g } = s.contentRect;
        if (!(h && d && f && g)) return !1;
        const m = s.container.getBoundingClientRect();
        p += m.left, u += m.top;
        const v = -1 * (p + .5 * f - (c + .5 * h)), b = -1 * (u + .5 * g - (l + .5 * d)), y = h / f;
        let w = this.option("zoomOpacity") || !1;
        return "auto" === w && (w = Math.abs(h / d - f / g) > .1), {
            x: v,
            y: b,
            scale: y,
            opacity: w
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($259ce7fa7b92febc$var$wt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $259ce7fa7b92febc$var$xt = "html", $259ce7fa7b92febc$var$Et = "image", $259ce7fa7b92febc$var$St = "map", $259ce7fa7b92febc$var$Pt = "youtube", $259ce7fa7b92febc$var$Ct = "vimeo", $259ce7fa7b92febc$var$Tt = "html5video", $259ce7fa7b92febc$var$Mt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && s.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else s.set(t, e);
    }
    let o = s + "", a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $259ce7fa7b92febc$var$Ot = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $259ce7fa7b92febc$var$At = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo"
];
class $259ce7fa7b92febc$var$Lt extends $259ce7fa7b92febc$var$_ {
    onBeforeInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onClearContent(t, e) {
        e.xhr && (e.xhr.abort(), e.xhr = null);
        const i = e.iframeEl;
        i && (i.onload = i.onerror = null, i.src = "//about:blank", e.iframeEl = null);
        const n = e.contentEl, s = e.placeholderEl;
        if ("inline" === e.type && n && s) n.classList.remove("fancybox__content"), "none" !== getComputedStyle(n).getPropertyValue("display") && (n.style.display = "none"), setTimeout(()=>{
            s && (n && s.parentNode && s.parentNode.insertBefore(n, s), s.remove());
        }, 0), e.contentEl = void 0, e.placeholderEl = void 0;
        else for(; e.el && e.el.firstChild;)e.el.removeChild(e.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $259ce7fa7b92febc$var$lt.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if (i.type === $259ce7fa7b92febc$var$Tt) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        i.type === $259ce7fa7b92febc$var$Ct ? o = {
            method: "pause",
            value: "true"
        } : i.type === $259ce7fa7b92febc$var$Pt && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.resizeIframe(t), this.setAspectRatio(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $259ce7fa7b92febc$var$rt.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($259ce7fa7b92febc$var$E(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const { type: e, iframeEl: i } = t;
        if (e === $259ce7fa7b92febc$var$Pt || e === $259ce7fa7b92febc$var$Ct) return;
        const n = null == i ? void 0 : i.parentElement;
        if (!i || !n) return;
        let s = t.autoSize;
        void 0 === s && (s = this.optionFor(t, "autoSize"));
        let o = t.width || 0, a = t.height || 0;
        o && a && (s = !1);
        const r = n && n.style;
        if (!1 !== t.preload && !1 !== s && r) try {
            const t = window.getComputedStyle(n), e = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = i.contentWindow;
            if (l) {
                const t = l.document, i = t.getElementsByTagName($259ce7fa7b92febc$var$xt)[0], n = t.body;
                r.width = "", n.style.overflow = "hidden", o = o || i.scrollWidth + e, r.width = `${o}px`, n.style.overflow = "", r.flex = "0 0 auto", r.height = `${n.scrollHeight}px`, a = i.scrollHeight + s;
            }
        } catch (t) {}
        if (o || a) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            o && "auto" !== o && (t.width = `${o}px`), a && "auto" !== a && (t.height = `${a}px`), Object.assign(r, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if (t.type === $259ce7fa7b92febc$var$Tt) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if (t.type !== $259ce7fa7b92febc$var$Pt && t.type !== $259ce7fa7b92febc$var$Ct) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = t.type === $259ce7fa7b92febc$var$Pt ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                t.type === $259ce7fa7b92febc$var$Pt && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = $259ce7fa7b92febc$var$xt, t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, $259ce7fa7b92febc$var$Pt), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $259ce7fa7b92febc$var$Mt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = $259ce7fa7b92febc$var$Pt;
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $259ce7fa7b92febc$var$Mt(e, this.optionFor(t, $259ce7fa7b92febc$var$Ct)), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = $259ce7fa7b92febc$var$Ct;
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $259ce7fa7b92febc$var$At.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = $259ce7fa7b92febc$var$Tt, t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = $259ce7fa7b92febc$var$Et : e.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf")), (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = $259ce7fa7b92febc$var$St) : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = $259ce7fa7b92febc$var$St), i = i || this.instance.option("defaultType"), t.type = i, i === $259ce7fa7b92febc$var$Et && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case $259ce7fa7b92febc$var$xt:
                    this.instance.setContent(t, e);
                    break;
                case $259ce7fa7b92febc$var$Tt:
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case $259ce7fa7b92febc$var$St:
                case $259ce7fa7b92febc$var$Pt:
                case $259ce7fa7b92febc$var$Ct:
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        const e = t.contentEl;
        if (!(t.el && e && t.type && [
            $259ce7fa7b92febc$var$Pt,
            $259ce7fa7b92febc$var$Ct,
            $259ce7fa7b92febc$var$Tt
        ].includes(t.type))) return;
        let i, n = t.width || "auto", s = t.height || "auto";
        if ("auto" === n || "auto" === s) {
            i = this.optionFor(t, "videoRatio");
            const e = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = e && e.length > 2 ? parseFloat(e[1]) / parseFloat(e[2]) : parseFloat(i + "");
        } else n && s && (i = n / s);
        if (!i) return;
        e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.offsetHeight;
        const o = e.getBoundingClientRect(), a = o.width || 1, r = o.height || 1;
        e.style.aspectRatio = i + "", i < a / r ? (s = "auto" === s ? r : Math.min(r, s), e.style.width = "auto", e.style.height = `${s}px`) : (n = "auto" === n ? a : Math.min(a, n), e.style.width = `${n}px`, e.style.height = "auto");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), e.on("clearContent", t.onClearContent), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), e.off("clearContent", t.onClearContent), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($259ce7fa7b92febc$var$Lt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$Ot
});
const $259ce7fa7b92febc$var$zt = "play", $259ce7fa7b92febc$var$Rt = "pause", $259ce7fa7b92febc$var$kt = "ready";
class $259ce7fa7b92febc$var$It extends $259ce7fa7b92febc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $259ce7fa7b92febc$var$kt
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $259ce7fa7b92febc$var$kt;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $259ce7fa7b92febc$var$P(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $259ce7fa7b92febc$var$zt, $259ce7fa7b92febc$var$P(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $259ce7fa7b92febc$var$kt) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $259ce7fa7b92febc$var$kt, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $259ce7fa7b92febc$var$S(i, "has-autoplay"), e !== $259ce7fa7b92febc$var$kt && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $259ce7fa7b92febc$var$zt && (t.state = $259ce7fa7b92febc$var$Rt, t.clear(), t.emit($259ce7fa7b92febc$var$Rt));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $259ce7fa7b92febc$var$zt) {
                if (t.state === $259ce7fa7b92febc$var$Rt && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $259ce7fa7b92febc$var$zt || this.state === $259ce7fa7b92febc$var$Rt ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($259ce7fa7b92febc$var$It, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $259ce7fa7b92febc$var$Dt extends $259ce7fa7b92febc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $259ce7fa7b92febc$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $259ce7fa7b92febc$var$lt.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $259ce7fa7b92febc$var$lt.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $259ce7fa7b92febc$var$It
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        i && e && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref, n = t.carousel;
        if (!i || !n) return;
        const s = e.panzoom;
        s && s.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($259ce7fa7b92febc$var$Dt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $259ce7fa7b92febc$var$Ft = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $259ce7fa7b92febc$var$jt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden";
}($259ce7fa7b92febc$var$jt || ($259ce7fa7b92febc$var$jt = {}));
const $259ce7fa7b92febc$var$Bt = "isResting", $259ce7fa7b92febc$var$Ht = "thumbWidth", $259ce7fa7b92febc$var$Nt = "thumbHeight", $259ce7fa7b92febc$var$_t = "thumbClipWidth";
let $259ce7fa7b92febc$var$$t = class extends $259ce7fa7b92febc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $259ce7fa7b92febc$var$jt.Init
        });
    }
    get isModern() {
        return "modern" === this.type;
    }
    onInitSlide(t, e) {
        const i = e.el ? e.el.dataset : void 0;
        i && (e.thumbSrc = i.thumbSrc || e.thumbSrc || "", e[$259ce7fa7b92febc$var$_t] = parseFloat(i[$259ce7fa7b92febc$var$_t] || "") || e[$259ce7fa7b92febc$var$_t] || 0, e[$259ce7fa7b92febc$var$Nt] = parseFloat(i.thumbHeight || "") || e[$259ce7fa7b92febc$var$Nt] || 0), this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var t;
        if (!this.isModern) return;
        const e = this.container, i = this.instance, n = i.panzoom, s = this.carousel, a = s ? s.panzoom : null, r = i.page;
        if (n && s && a) {
            if (n.isDragging) {
                $259ce7fa7b92febc$var$S(e, this.cn($259ce7fa7b92febc$var$Bt));
                let n = (null === (t = s.pages[r]) || void 0 === t ? void 0 : t.pos) || 0;
                n += i.getProgress(r) * (this[$259ce7fa7b92febc$var$_t] + this.thumbGap);
                let o = a.getBounds();
                -1 * n > o.x.min && -1 * n < o.x.max && a.panTo({
                    x: -1 * n,
                    friction: .12
                });
            } else $259ce7fa7b92febc$var$o(e, this.cn($259ce7fa7b92febc$var$Bt), n.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const t of this.instance.slides || [])this.resizeModernSlide(t);
        this.shiftModern();
    }
    isDisabled() {
        const t = this.option("minCount") || 0;
        if (t) {
            const e = this.instance;
            let i = 0;
            for (const t of e.slides || [])t.thumbSrc && i++;
            if (i < t) return !0;
        }
        const e = this.option("type");
        return [
            "modern",
            "classic"
        ].indexOf(e) < 0;
    }
    getThumb(t) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                [
                    "%i",
                    t.index
                ],
                [
                    "%d",
                    t.index + 1
                ],
                [
                    "%s",
                    t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                ]
            ])
        };
    }
    addSlide(t) {
        const e = this.carousel;
        e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
        const t = [];
        for (const e of this.instance.slides || [])t.push(this.getThumb(e));
        return t;
    }
    resizeModernSlide(t) {
        this.isModern && (t[$259ce7fa7b92febc$var$Ht] = t[$259ce7fa7b92febc$var$_t] && t[$259ce7fa7b92febc$var$Nt] ? Math.round(this[$259ce7fa7b92febc$var$Nt] * (t[$259ce7fa7b92febc$var$_t] / t[$259ce7fa7b92febc$var$Nt])) : this[$259ce7fa7b92febc$var$Ht]);
    }
    updateProps() {
        const t = this.container;
        if (!t) return;
        const e = (e)=>parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + e)) || 0;
        this.thumbGap = e("gap"), this.thumbExtraGap = e("extra-gap"), this[$259ce7fa7b92febc$var$Ht] = e("width") || 40, this[$259ce7fa7b92febc$var$_t] = e("clip-width") || 40, this[$259ce7fa7b92febc$var$Nt] = e("height") || 40;
    }
    build() {
        const t = this;
        if (t.state !== $259ce7fa7b92febc$var$jt.Init) return;
        if (t.isDisabled()) return void t.emit("disabled");
        const e = t.instance, i = e.container, n = t.getSlides(), s = t.option("type");
        t.type = s;
        const o = t.option("parentEl"), a = t.cn("container"), r = t.cn("track");
        let l = null == o ? void 0 : o.querySelector("." + a);
        l || (l = document.createElement("div"), $259ce7fa7b92febc$var$P(l, a), o ? o.appendChild(l) : i.after(l)), $259ce7fa7b92febc$var$P(l, `is-${s}`), $259ce7fa7b92febc$var$P(i, t.cn("hasThumbs")), t.container = l, t.updateProps();
        let c = l.querySelector("." + r);
        c || (c = document.createElement("div"), $259ce7fa7b92febc$var$P(c, t.cn("track")), l.appendChild(c)), t.track = c;
        const h = $259ce7fa7b92febc$var$u({}, {
            track: c,
            infinite: !1,
            center: !0,
            fill: "classic" === s,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: .25,
            friction: .12,
            Panzoom: {
                maxVelocity: 0
            },
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, t.option("Carousel") || {}, {
            Sync: {
                target: e
            },
            slides: n
        }), d = new e.constructor(l, h);
        d.on("createSlide", (e, i)=>{
            t.setProps(i.index), t.emit("createSlide", i, i.el);
        }), d.on("ready", ()=>{
            t.shiftModern(), t.emit("ready");
        }), d.on("refresh", ()=>{
            t.shiftModern();
        }), d.on("Panzoom.click", (e, i, n)=>{
            t.onClick(n);
        }), t.carousel = d, t.state = $259ce7fa7b92febc$var$jt.Ready;
    }
    onClick(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, { pages: i, page: n } = e, s = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return [
                    parseInt(e.dataset.carouselIndex || "", 10) || 0,
                    e
                ];
            }
            return [
                -1,
                void 0
            ];
        }, o = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? s(i) : [
                -1,
                void 0
            ];
        };
        let [a, r] = s(t.target);
        if (a > -1) return;
        const l = this[$259ce7fa7b92febc$var$_t], c = t.clientX, h = t.clientY;
        let [d, u] = o(c - l, h), [p, f] = o(c + l, h);
        u && f ? (a = Math.abs(c - u.getBoundingClientRect().right) < Math.abs(c - f.getBoundingClientRect().left) ? d : p, a === n && (a = a === d ? p : d)) : u ? a = d : f && (a = p), a > -1 && i[a] && e.slideTo(a);
    }
    getShift(t) {
        var e;
        const i = this, { instance: n } = i, s = i.carousel;
        if (!n || !s) return 0;
        const o = i[$259ce7fa7b92febc$var$Ht], a = i[$259ce7fa7b92febc$var$_t], r = i.thumbGap, l = i.thumbExtraGap;
        if (!(null === (e = s.slides[t]) || void 0 === e ? void 0 : e.el)) return 0;
        const c = .5 * (o - a), h = n.pages.length - 1;
        let d = n.getProgress(0), u = n.getProgress(h), p = n.getProgress(t, !1, !0), f = 0, g = c + l + r;
        const m = d < 0 && d > -1, v = u > 0 && u < 1;
        return 0 === t ? (f = g * Math.abs(d), v && 1 === d && (f -= g * Math.abs(u))) : t === h ? (f = g * Math.abs(u) * -1, m && -1 === u && (f += g * Math.abs(d))) : m || v ? (f = -1 * g, f += g * Math.abs(d), f += g * (1 - Math.abs(u))) : f = g * p, f;
    }
    setProps(e) {
        var i;
        const n = this;
        if (!n.isModern) return;
        const { instance: s } = n, o = n.carousel;
        if (s && o) {
            const a = null === (i = o.slides[e]) || void 0 === i ? void 0 : i.el;
            if (a && a.childNodes.length) {
                let i = $259ce7fa7b92febc$var$t(1 - Math.abs(s.getProgress(e))), o = $259ce7fa7b92febc$var$t(n.getShift(e));
                a.style.setProperty("--progress", i ? i + "" : ""), a.style.setProperty("--shift", o + "");
            }
        }
    }
    shiftModern() {
        const t = this;
        if (!t.isModern) return;
        const { instance: e, track: i } = t, n = e.panzoom, s = t.carousel;
        if (!(e && i && n && s)) return;
        if (n.state === $259ce7fa7b92febc$var$m.Init || n.state === $259ce7fa7b92febc$var$m.Destroy) return;
        for (const i of e.slides)t.setProps(i.index);
        let o = (t[$259ce7fa7b92febc$var$_t] + t.thumbGap) * (s.slides.length || 0);
        i.style.setProperty("--width", o + "");
    }
    cleanup() {
        const t = this;
        t.carousel && t.carousel.destroy(), t.carousel = null, t.container && t.container.remove(), t.container = null, t.track && t.track.remove(), t.track = null, t.state = $259ce7fa7b92febc$var$jt.Init, $259ce7fa7b92febc$var$S(t.instance.container, t.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $259ce7fa7b92febc$var$B.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.on("Panzoom.refresh", t.onRefresh);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.off("Panzoom.refresh", t.onRefresh), t.cleanup();
    }
};
Object.defineProperty($259ce7fa7b92febc$var$$t, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$Ft
});
const $259ce7fa7b92febc$var$Wt = Object.assign(Object.assign({}, $259ce7fa7b92febc$var$Ft), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $259ce7fa7b92febc$var$Xt = "is-masked", $259ce7fa7b92febc$var$qt = "aria-hidden";
class $259ce7fa7b92febc$var$Yt extends $259ce7fa7b92febc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && !t.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(t, e) {
        e.stopPropagation();
    }
    onCreateSlide(t, e) {
        var i, n, s;
        const o = (null === (s = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[e.index]) || void 0 === s ? void 0 : s.type) || "", a = e.el;
        if (a && o) {
            let t = `for-${o}`;
            [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(o) && (t += " for-video"), $259ce7fa7b92febc$var$P(a, t);
        }
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $259ce7fa7b92febc$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $259ce7fa7b92febc$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: this.onClick,
            createSlide: this.onCreateSlide
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $259ce7fa7b92febc$var$$t
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $259ce7fa7b92febc$var$jt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        if (t && !t.isDisabled()) return t.state === $259ce7fa7b92febc$var$jt.Hidden ? (t.state = $259ce7fa7b92febc$var$jt.Init, void t.build()) : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const t = this.ref;
        if (!t || t.isDisabled()) return;
        const e = t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($259ce7fa7b92febc$var$qt), e.classList.remove($259ce7fa7b92febc$var$Xt), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($259ce7fa7b92febc$var$Xt), e.setAttribute($259ce7fa7b92febc$var$qt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || !t.state) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $259ce7fa7b92febc$var$rt.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($259ce7fa7b92febc$var$Yt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$Wt
});
const $259ce7fa7b92febc$var$Vt = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $259ce7fa7b92febc$var$Zt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($259ce7fa7b92febc$var$Zt || ($259ce7fa7b92febc$var$Zt = {}));
const $259ce7fa7b92febc$var$Ut = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $259ce7fa7b92febc$var$Gt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
}, $259ce7fa7b92febc$var$Kt = "has-toolbar", $259ce7fa7b92febc$var$Jt = "fancybox__toolbar";
class $259ce7fa7b92febc$var$Qt extends $259ce7fa7b92febc$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $259ce7fa7b92febc$var$Zt.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $259ce7fa7b92febc$var$P(i, $259ce7fa7b92febc$var$Jt + "__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $259ce7fa7b92febc$var$P(r, "is-absolute"), this.state = $259ce7fa7b92febc$var$Zt.Ready, this.onRefresh();
        } else this.state = $259ce7fa7b92febc$var$Zt.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $259ce7fa7b92febc$var$E(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $259ce7fa7b92febc$var$lt.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t;
        let i = e.querySelector("." + $259ce7fa7b92febc$var$Jt);
        return i || (i = document.createElement("div"), $259ce7fa7b92febc$var$P(i, $259ce7fa7b92febc$var$Jt), e.prepend(i)), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $259ce7fa7b92febc$var$P(t, $259ce7fa7b92febc$var$Kt), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !$259ce7fa7b92febc$var$ot()) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $259ce7fa7b92febc$var$Vt[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $259ce7fa7b92febc$var$Vt[t]) {
            const e = $259ce7fa7b92febc$var$Vt[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $259ce7fa7b92febc$var$P(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($259ce7fa7b92febc$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $259ce7fa7b92febc$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($259ce7fa7b92febc$var$Gt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $259ce7fa7b92febc$var$Zt.Disabled;
        const e = this.instance.container;
        e && $259ce7fa7b92febc$var$S(e, $259ce7fa7b92febc$var$Kt);
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.removeContainer();
    }
}
Object.defineProperty($259ce7fa7b92febc$var$Qt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$Ut
});
const $259ce7fa7b92febc$var$te = {
    Hash: class extends $259ce7fa7b92febc$var$_ {
        onReady() {
            $259ce7fa7b92febc$var$ht = !1;
        }
        onChange(t) {
            $259ce7fa7b92febc$var$ut && clearTimeout($259ce7fa7b92febc$var$ut);
            const { hash: e } = $259ce7fa7b92febc$var$pt(), { hash: i } = $259ce7fa7b92febc$var$ft(), n = t.isOpeningSlide(t.getSlide());
            n && ($259ce7fa7b92febc$var$ct = i === e ? "" : i), e && e !== i && ($259ce7fa7b92febc$var$ut = setTimeout(()=>{
                try {
                    if (t.state === $259ce7fa7b92febc$var$rt.Ready) {
                        let t = "replaceState";
                        n && !$259ce7fa7b92febc$var$dt && (t = "pushState", $259ce7fa7b92febc$var$dt = !0), window.history[t]({}, document.title, window.location.pathname + window.location.search + e);
                    }
                } catch (t) {}
            }, 300));
        }
        onClose(t) {
            if ($259ce7fa7b92febc$var$ut && clearTimeout($259ce7fa7b92febc$var$ut), !$259ce7fa7b92febc$var$ht && $259ce7fa7b92febc$var$dt) return $259ce7fa7b92febc$var$dt = !1, $259ce7fa7b92febc$var$ht = !1, void window.history.back();
            if (!$259ce7fa7b92febc$var$ht) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + ($259ce7fa7b92febc$var$ct || ""));
            } catch (t) {}
        }
        attach() {
            const t = this.instance;
            t.on("ready", this.onReady), t.on([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.on("close", this.onClose);
        }
        detach() {
            const t = this.instance;
            t.off("ready", this.onReady), t.off([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.off("close", this.onClose);
        }
        static parseURL() {
            return $259ce7fa7b92febc$var$ft();
        }
        static startFromUrl() {
            $259ce7fa7b92febc$var$gt();
        }
        static destroy() {
            window.removeEventListener("hashchange", $259ce7fa7b92febc$var$vt, !1);
        }
    },
    Html: $259ce7fa7b92febc$var$Lt,
    Images: $259ce7fa7b92febc$var$wt,
    Slideshow: $259ce7fa7b92febc$var$Dt,
    Thumbs: $259ce7fa7b92febc$var$Yt,
    Toolbar: $259ce7fa7b92febc$var$Qt
}, $259ce7fa7b92febc$var$ee = "with-fancybox", $259ce7fa7b92febc$var$ie = "hide-scrollbar", $259ce7fa7b92febc$var$ne = "--fancybox-scrollbar-compensate", $259ce7fa7b92febc$var$se = "--fancybox-body-margin", $259ce7fa7b92febc$var$oe = "aria-hidden", $259ce7fa7b92febc$var$ae = "is-using-tab", $259ce7fa7b92febc$var$re = "is-animated", $259ce7fa7b92febc$var$le = "is-compact", $259ce7fa7b92febc$var$ce = "is-loading", $259ce7fa7b92febc$var$he = "is-opening", $259ce7fa7b92febc$var$de = "has-caption", $259ce7fa7b92febc$var$ue = "disabled", $259ce7fa7b92febc$var$pe = "tabindex", $259ce7fa7b92febc$var$fe = "download", $259ce7fa7b92febc$var$ge = "href", $259ce7fa7b92febc$var$me = "src", $259ce7fa7b92febc$var$ve = (t)=>"string" == typeof t, $259ce7fa7b92febc$var$be = function() {
    var t = window.getSelection();
    return !!t && "Range" === t.type;
};
let $259ce7fa7b92febc$var$ye, $259ce7fa7b92febc$var$we = null, $259ce7fa7b92febc$var$xe = null, $259ce7fa7b92febc$var$Ee = 0, $259ce7fa7b92febc$var$Se = 0, $259ce7fa7b92febc$var$Pe = 0, $259ce7fa7b92febc$var$Ce = 0;
const $259ce7fa7b92febc$var$Te = new Map;
let $259ce7fa7b92febc$var$Me = 0;
class $259ce7fa7b92febc$export$cb45b08d97cdc4fd extends $259ce7fa7b92febc$var$g {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "startedFs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $259ce7fa7b92febc$var$rt.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), $259ce7fa7b92febc$var$ye || ($259ce7fa7b92febc$var$ye = $259ce7fa7b92febc$var$ot()), this.id = e.id || ++$259ce7fa7b92febc$var$Me, $259ce7fa7b92febc$var$Te.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $259ce7fa7b92febc$var$rt.Destroy) return;
        this.state = $259ce7fa7b92febc$var$rt.Init, this.attachPlugins(Object.assign(Object.assign({}, $259ce7fa7b92febc$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), this.emit("attachPlugins"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$259ce7fa7b92febc$var$et) return;
            const t = document, e = t.body, i = t.documentElement;
            if (e.classList.contains($259ce7fa7b92febc$var$ie)) return;
            let n = window.innerWidth - i.getBoundingClientRect().width;
            const s = parseFloat(window.getComputedStyle(e).marginRight);
            n < 0 && (n = 0), i.style.setProperty($259ce7fa7b92febc$var$ne, `${n}px`), s && e.style.setProperty($259ce7fa7b92febc$var$se, `${s}px`), e.classList.add($259ce7fa7b92febc$var$ie);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $259ce7fa7b92febc$var$rt.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute($259ce7fa7b92febc$var$oe, "false");
            }, 16);
        };
        this.option("Fullscreen.autoStart") && $259ce7fa7b92febc$var$ye && !$259ce7fa7b92febc$var$ye.isFullscreen() ? $259ce7fa7b92febc$var$ye.request().then(()=>{
            this.startedFs = !0, t();
        }).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $259ce7fa7b92febc$var$n(this.localize(this.option("tpl.main") || ""));
        if (s) {
            if (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($259ce7fa7b92febc$var$le, this.isCompact), $259ce7fa7b92febc$var$P(s, this.option("mainClass") || ""), $259ce7fa7b92febc$var$P(s, $259ce7fa7b92febc$var$he), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $259ce7fa7b92febc$var$P(document.documentElement, $259ce7fa7b92febc$var$ee), $259ce7fa7b92febc$var$we && $259ce7fa7b92febc$var$xe || ($259ce7fa7b92febc$var$we = document.createElement("span"), $259ce7fa7b92febc$var$P($259ce7fa7b92febc$var$we, "fancybox-focus-guard"), $259ce7fa7b92febc$var$we.setAttribute($259ce7fa7b92febc$var$pe, "0"), $259ce7fa7b92febc$var$we.setAttribute($259ce7fa7b92febc$var$oe, "true"), $259ce7fa7b92febc$var$we.setAttribute("aria-label", "Focus guard"), $259ce7fa7b92febc$var$xe = $259ce7fa7b92febc$var$we.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($259ce7fa7b92febc$var$we, s), null === (e = s.parentElement) || void 0 === e || e.append($259ce7fa7b92febc$var$xe)), s.addEventListener("mousedown", (t)=>{
                $259ce7fa7b92febc$var$Ee = t.pageX, $259ce7fa7b92febc$var$Se = t.pageY, $259ce7fa7b92febc$var$S(s, $259ce7fa7b92febc$var$ae);
            }), this.option("closeExisting")) for (const t of $259ce7fa7b92febc$var$Te.values())t.id !== this.id && t.close();
            else this.option("animated") && ($259ce7fa7b92febc$var$P(s, $259ce7fa7b92febc$var$re), setTimeout(()=>{
                this.isClosing() || $259ce7fa7b92febc$var$S(s, $259ce7fa7b92febc$var$re);
            }, 350));
            this.emit("initLayout");
        }
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $259ce7fa7b92febc$export$144901db2ea8e967(n, $259ce7fa7b92febc$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            this.manageCaption();
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            this.clearContent(i), i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $259ce7fa7b92febc$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $259ce7fa7b92febc$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute($259ce7fa7b92febc$var$ue), i.removeAttribute($259ce7fa7b92febc$var$pe)) : (i.setAttribute($259ce7fa7b92febc$var$ue, ""), i.setAttribute($259ce7fa7b92febc$var$pe, "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute($259ce7fa7b92febc$var$ue), i.removeAttribute($259ce7fa7b92febc$var$pe)) : (i.setAttribute($259ce7fa7b92febc$var$ue, ""), i.setAttribute($259ce7fa7b92febc$var$pe, "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || !$259ce7fa7b92febc$var$ve(i[$259ce7fa7b92febc$var$me]) || (n = i[$259ce7fa7b92febc$var$me]);
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute($259ce7fa7b92febc$var$ue), t.removeAttribute($259ce7fa7b92febc$var$pe), t.setAttribute($259ce7fa7b92febc$var$ge, n), t.setAttribute($259ce7fa7b92febc$var$fe, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute($259ce7fa7b92febc$var$ue, ""), t.setAttribute($259ce7fa7b92febc$var$pe, "-1"), t.removeAttribute($259ce7fa7b92febc$var$ge), t.removeAttribute($259ce7fa7b92febc$var$fe));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e;
        const { container: i, isCompact: n } = this;
        if (!i || this.isClosing()) return;
        !n && this.option("idle") && this.resetIdle();
        const s = t.composedPath()[0];
        if (s.closest(".fancybox-spinner") || s.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (s.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (s.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        if ("click" === t.type && 0 === t.detail) return;
        if (Math.abs(t.pageX - $259ce7fa7b92febc$var$Ee) > 30 || Math.abs(t.pageY - $259ce7fa7b92febc$var$Se) > 30) return;
        const o = document.activeElement;
        if ($259ce7fa7b92febc$var$be() && o && i.contains(o)) return;
        if (n && "image" === (null === (e = this.getSlide()) || void 0 === e ? void 0 : e.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let a = !1;
        if (s.closest(".fancybox__content")) {
            if (o) {
                if (o.closest("[contenteditable]")) return;
                s.matches($259ce7fa7b92febc$var$nt) || o.blur();
            }
            if ($259ce7fa7b92febc$var$be()) return;
            a = this.option("contentClick");
        } else s.closest(".fancybox__carousel") && !s.matches($259ce7fa7b92febc$var$nt) && (a = this.option("backdropClick"));
        "close" === a ? (t.preventDefault(), this.close(t)) : "next" === a ? (t.preventDefault(), this.next()) : "prev" === a && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        const e = t.target;
        let n = this.option("wheel", t);
        e.closest(".fancybox__thumbs") && (n = "slide");
        const s = "slide" === n, o = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), a = Math.max(-1, Math.min(1, o)), r = Date.now();
        this.pwt && r - this.pwt < 300 ? s && t.preventDefault() : (this.pwt = r, this.emit("wheel", t, a), t.defaultPrevented || ("close" === n ? (t.preventDefault(), this.close(t)) : "slide" === n && ($259ce7fa7b92febc$var$i(e) || (t.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
        window.scrollTo($259ce7fa7b92febc$var$Pe, $259ce7fa7b92febc$var$Ce);
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $259ce7fa7b92febc$var$E(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        if ("Tab" === t.key ? $259ce7fa7b92febc$var$P(this.container, $259ce7fa7b92febc$var$ae) : $259ce7fa7b92febc$var$S(this.container, $259ce7fa7b92febc$var$ae), t.ctrlKey || t.altKey || t.shiftKey) return;
        this.emit("keydown", e, t);
        const a = i[e];
        a && "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = this.container;
        if (!t) return;
        const e = this.isCompact;
        t.classList.toggle($259ce7fa7b92febc$var$le, e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $259ce7fa7b92febc$var$Zt.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $259ce7fa7b92febc$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $259ce7fa7b92febc$var$P(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = this.container;
        if (!s) return;
        $259ce7fa7b92febc$var$S(s, $259ce7fa7b92febc$var$de);
        const o = this.isCompact || this.option("commonCaption"), a = !o;
        if (this.caption && this.stop(this.caption), a && this.caption && (this.caption.remove(), this.caption = null), o && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $259ce7fa7b92febc$var$S(t.el, $259ce7fa7b92febc$var$de), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || o && !this.isCurrentSlide(t)) return;
        const r = t.el;
        let l = this.optionFor(t, "caption", "");
        if (!l) return void (o && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let c = null;
        if (a) {
            if (c = t.captionEl || null, r && !c) {
                const e = n + `_${this.id}_${t.index}`;
                c = document.createElement("div"), $259ce7fa7b92febc$var$P(c, n), c.setAttribute("id", e), t.captionEl = r.appendChild(c), $259ce7fa7b92febc$var$P(r, $259ce7fa7b92febc$var$de), r.setAttribute("aria-labelledby", e);
            }
        } else {
            if (c = this.caption, c || (c = s.querySelector("." + n)), !c) {
                c = document.createElement("div"), c.dataset.fancyboxCaption = "", $259ce7fa7b92febc$var$P(c, n);
                (this.footer || s).prepend(c);
            }
            $259ce7fa7b92febc$var$P(s, $259ce7fa7b92febc$var$de), this.caption = c;
        }
        c && (c.innerHTML = "", $259ce7fa7b92febc$var$ve(l) || "number" == typeof l ? c.innerHTML = l + "" : l instanceof HTMLElement && c.appendChild(l));
    }
    checkFocus(t) {
        this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport;
        if (!s || !o) return;
        if (!t && i && s.contains(i)) return;
        const a = this.getSlide(), r = a && a.state === $259ce7fa7b92febc$var$lt.Ready ? a.el : null;
        if (!r || r.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const l = Array.from(s.querySelectorAll($259ce7fa7b92febc$var$nt));
        let c = [], h = null;
        for (let t of l){
            const e = !t.offsetParent || !!t.closest('[aria-hidden="true"]'), i = r && r.contains(t), n = !o.contains(t);
            if (t === s || (i || n) && !e) {
                c.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && h || (h = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let d = null;
        t ? (!n || c.indexOf(n) < 0) && (d = h || s, c.length && (i === $259ce7fa7b92febc$var$xe ? d = c[0] : this.lastFocus !== s && i !== $259ce7fa7b92febc$var$we || (d = c[c.length - 1]))) : d = a && "image" === a.type ? s : h || s, d && $259ce7fa7b92febc$var$st(d), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $259ce7fa7b92febc$var$S(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $259ce7fa7b92febc$var$P(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($259ce7fa7b92febc$var$E(e) ? o = e : (o = $259ce7fa7b92febc$var$n(e + ""), $259ce7fa7b92febc$var$E(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $259ce7fa7b92febc$var$E(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $259ce7fa7b92febc$var$E(o) ? ($259ce7fa7b92febc$var$P(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), "none" === o.style.display && (o.style.display = ""), "none" === getComputedStyle(o).getPropertyValue("display") && (o.style.display = t.display || this.option("defaultDisplay") || "flex"), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $259ce7fa7b92febc$var$lt.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $259ce7fa7b92febc$var$lt.Ready, this.emit("done", t), $259ce7fa7b92febc$var$P(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            var e;
            null === (e = t.panzoom) || void 0 === e || e.updateControls(), this.option("autoFocus") && this.focus();
        }), this.isOpeningSlide(t) && ($259ce7fa7b92febc$var$S(this.container, $259ce7fa7b92febc$var$he), !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $259ce7fa7b92febc$var$lt.Loading;
        const e = t.el;
        if (!e) return;
        $259ce7fa7b92febc$var$P(e, $259ce7fa7b92febc$var$ce), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $259ce7fa7b92febc$var$lt.Loading) {
                let i = $259ce7fa7b92febc$var$n($259ce7fa7b92febc$var$x);
                $259ce7fa7b92febc$var$P(i, "fancybox-spinner"), t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($259ce7fa7b92febc$var$S(e, $259ce7fa7b92febc$var$ce), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $259ce7fa7b92febc$var$lt.Loading && (this.emit("loaded", t), t.state = $259ce7fa7b92febc$var$lt.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        if (void 0 === t.state) return;
        this.emit("clearContent", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0);
        const e = t.el;
        e && ($259ce7fa7b92febc$var$S(e, "has-error"), $259ce7fa7b92febc$var$S(e, "has-unknown"), $259ce7fa7b92febc$var$S(e, `has-${t.type || "unknown"}`)), t.closeBtnEl && t.closeBtnEl.remove(), t.closeBtnEl = void 0, t.captionEl && t.captionEl.remove(), t.captionEl = void 0, t.spinnerEl && t.spinnerEl.remove(), t.spinnerEl = void 0;
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = ()=>{
            this.proceedClose(t, e);
        };
        this.startedFs && $259ce7fa7b92febc$var$ye && $259ce7fa7b92febc$var$ye.isFullscreen() ? Promise.resolve($259ce7fa7b92febc$var$ye.exit()).then(()=>n()) : n();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $259ce7fa7b92febc$var$P(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $259ce7fa7b92febc$var$S(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        $259ce7fa7b92febc$var$ye && ($259ce7fa7b92febc$var$ye.isFullscreen() ? $259ce7fa7b92febc$var$ye.exit() : $259ce7fa7b92febc$var$ye.request().then(()=>{
            this.startedFs = !0;
        }));
    }
    isClosing() {
        return [
            $259ce7fa7b92febc$var$rt.Closing,
            $259ce7fa7b92febc$var$rt.CustomClosing,
            $259ce7fa7b92febc$var$rt.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $259ce7fa7b92febc$var$rt.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($259ce7fa7b92febc$var$tt(r) ? $259ce7fa7b92febc$var$st(r) : r.focus()), s && ($259ce7fa7b92febc$var$S(s, $259ce7fa7b92febc$var$he), $259ce7fa7b92febc$var$P(s, "is-closing"), s.setAttribute($259ce7fa7b92febc$var$oe, "true"), this.option("animated") && $259ce7fa7b92febc$var$P(s, $259ce7fa7b92febc$var$re), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $259ce7fa7b92febc$var$lt.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        $259ce7fa7b92febc$var$Pe = window.scrollX, $259ce7fa7b92febc$var$Ce = window.scrollY, window.addEventListener("scroll", this.onScroll), this.emit("close", t), this.state !== $259ce7fa7b92febc$var$rt.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $259ce7fa7b92febc$var$rt.Destroy) return;
        window.removeEventListener("scroll", this.onScroll), this.state = $259ce7fa7b92febc$var$rt.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $259ce7fa7b92febc$var$Te.delete(this.id);
        const i = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($259ce7fa7b92febc$var$we && ($259ce7fa7b92febc$var$we.remove(), $259ce7fa7b92febc$var$we = null), $259ce7fa7b92febc$var$xe && ($259ce7fa7b92febc$var$xe.remove(), $259ce7fa7b92febc$var$xe = null), $259ce7fa7b92febc$var$S(document.documentElement, $259ce7fa7b92febc$var$ee), (()=>{
            if (!$259ce7fa7b92febc$var$et) return;
            const t = document, e = t.body;
            e.classList.remove($259ce7fa7b92febc$var$ie), e.style.setProperty($259ce7fa7b92febc$var$se, ""), t.documentElement.style.setProperty($259ce7fa7b92febc$var$ne, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$259ce7fa7b92febc$var$et) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : $259ce7fa7b92febc$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, $259ce7fa7b92febc$var$ve(e) && (s = e), "object" == typeof i && (o = i || {})), !n || !$259ce7fa7b92febc$var$E(n)) return;
        s = s || "[data-fancybox]";
        const a = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $259ce7fa7b92febc$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $259ce7fa7b92febc$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ($259ce7fa7b92febc$var$ve(t) ? (i = document.body, n = t) : (i = t, $259ce7fa7b92febc$var$ve(e) && (n = e)), !i) return;
        const s = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($259ce7fa7b92febc$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $259ce7fa7b92febc$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $259ce7fa7b92febc$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $259ce7fa7b92febc$export$cb45b08d97cdc4fd.fromEvent);
        $259ce7fa7b92febc$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$259ce7fa7b92febc$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $259ce7fa7b92febc$var$u({}, $259ce7fa7b92febc$var$at, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const p = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance();
        return p && p.options.triggerEl && r.indexOf(p.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $259ce7fa7b92febc$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e, i) {
        let n = null, s = "", o = {};
        if ($259ce7fa7b92febc$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : t instanceof HTMLElement && $259ce7fa7b92febc$var$ve(e) && (n = t, s = e, "object" == typeof i && (o = i || {})), !n || !s) return !1;
        const a = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.openers.get(n);
        return !!a && (o = $259ce7fa7b92febc$var$u({}, a.get(s) || {}, o), !!o && $259ce7fa7b92febc$export$cb45b08d97cdc4fd.fromNodes(Array.from(n.querySelectorAll(s)), o));
    }
    static fromNodes(t, e) {
        e = $259ce7fa7b92febc$var$u({}, $259ce7fa7b92febc$var$at, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t[$259ce7fa7b92febc$var$me] || n.getAttribute($259ce7fa7b92febc$var$ge) || n.getAttribute("currentSrc") || n.getAttribute($259ce7fa7b92febc$var$me) || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o[$259ce7fa7b92febc$var$me] || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset[$259ce7fa7b92febc$var$me] || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t){
                let i = t[e] + "";
                i = "false" !== i && ("true" === i || i), l[e] = i;
            }
            i.push(l);
        }
        return new $259ce7fa7b92febc$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $259ce7fa7b92febc$var$Te.get(t);
        return Array.from($259ce7fa7b92febc$var$Te.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $259ce7fa7b92febc$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $259ce7fa7b92febc$var$Te.values())t.close(...e);
        else {
            const t = $259ce7fa7b92febc$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($259ce7fa7b92febc$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($259ce7fa7b92febc$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$at
}), Object.defineProperty($259ce7fa7b92febc$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $259ce7fa7b92febc$var$te
}), Object.defineProperty($259ce7fa7b92febc$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});


(0, $259ce7fa7b92febc$export$cb45b08d97cdc4fd).bind('[data-fancybox]', {});


(0, $84556724c483b9e3$export$2e2bcd8739ae039).start();
console.debug('hello!');
// Toggle dropdown
const $80dfc362fc983cdc$var$hamburgerButton = document.getElementById('hamburger');
const $80dfc362fc983cdc$var$closeButtons = document.getElementsByClassName('close');
const $80dfc362fc983cdc$var$firstLevelMenu = document.getElementById('first-level-menu');
const $80dfc362fc983cdc$var$subMenuButton = document.getElementById('open-submenu-arrow');
const $80dfc362fc983cdc$var$secondLevelMenu = document.getElementById('second-level-menu');
const $80dfc362fc983cdc$var$closeSubmenuButton = document.getElementById('close-submenu-arrow');
if ($80dfc362fc983cdc$var$hamburgerButton) {
    $80dfc362fc983cdc$var$hamburgerButton.addEventListener('click', ()=>{
        $80dfc362fc983cdc$var$firstLevelMenu.classList.toggle('open');
    });
    if ($80dfc362fc983cdc$var$closeSubmenuButton) $80dfc362fc983cdc$var$closeSubmenuButton.addEventListener('click', ()=>{
        $80dfc362fc983cdc$var$secondLevelMenu.classList.toggle('open');
    });
    Array.from($80dfc362fc983cdc$var$closeButtons).forEach(function(element) {
        element.addEventListener('click', ()=>{
            $80dfc362fc983cdc$var$firstLevelMenu.classList.remove('open');
            $80dfc362fc983cdc$var$secondLevelMenu.classList.remove('open');
        });
        element.addEventListener('keyup', (e)=>{
            if (e.code === 'Enter') {
                $80dfc362fc983cdc$var$firstLevelMenu.classList.remove('open');
                $80dfc362fc983cdc$var$secondLevelMenu.classList.remove('open');
            }
        });
    });
}
let $80dfc362fc983cdc$var$width = document.body.clientWidth;
if ($80dfc362fc983cdc$var$width < 900) $80dfc362fc983cdc$var$subMenuButton.addEventListener('click', ()=>{
    $80dfc362fc983cdc$var$secondLevelMenu.classList.toggle('open');
});
else $80dfc362fc983cdc$var$subMenuButton.addEventListener('keyup', (e)=>{
    if (e.code === 'Enter') $80dfc362fc983cdc$var$secondLevelMenu.classList.toggle('openAccess');
});
document.onkeydown = (evt)=>{
    if (evt.code === 'Escape' && $80dfc362fc983cdc$var$secondLevelMenu.classList.contains('open')) $80dfc362fc983cdc$var$secondLevelMenu.classList.remove('openAccess');
};
const $80dfc362fc983cdc$var$onresize = ()=>{
    $80dfc362fc983cdc$var$width = document.body.clientWidth;
};
window.addEventListener('resize', $80dfc362fc983cdc$var$onresize);

})();
//# sourceMappingURL=main.js.map
